/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        list: __webpack_require__(18).people
    },
    mutations: {
        setPeople: function setPeople(state, people) {
            state.list = people;
        }
    },
    getters: {
        people: function people(state) {
            return state.people.list;
        }
    }
});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_app__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_people__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model__ = __webpack_require__(6);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2__view_app__["a" /* default */].store = new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
    modules: __WEBPACK_IMPORTED_MODULE_5__model__["a" /* default */]
});

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_4__view_people__["a" /* default */]
    }]
});

__WEBPACK_IMPORTED_MODULE_2__view_app__["a" /* default */].router = router;

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__view_app__["a" /* default */]));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(10).polyfill();


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    init: function init() {
        if (typeof document !== 'undefined') {
            window.addEventListener('resize', this.sendHeight.bind(this, {}));

            setInterval(this.sendHeight.bind(this, {}), 200);
        }
    },
    sendHeight: function sendHeight(opts) {
        var heights = [];

        if (typeof document !== 'undefined' && typeof parent !== 'undefined' && parent) {
            var height = document.body.offsetHeight;

            if (typeof opts == 'undefined' || !opts) {
                opts = {};
            }

            opts.height = height + 10;

            parent.postMessage(opts, "*");

            heights.unshift(height + 10);

            if (heights.length > 5) {
                heights.pop();
            }
        }
    },
    scrollTo: function scrollTo(num) {
        this.sendHeight({
            scrollTo: num
        });
    },
    setHash: function setHash(route) {
        this.sendHeight({
            route: route
        });
    }
});

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__people__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
	people: __WEBPACK_IMPORTED_MODULE_0__people__["a" /* default */]
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controller_pym__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_app_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_app_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__view_app_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__overview__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        overview: __WEBPACK_IMPORTED_MODULE_2__overview__["a" /* default */]
    },
    el: '#fCCAdvisors',
    render: __WEBPACK_IMPORTED_MODULE_1__view_app_html___default.a.render,
    staticRenderFns: __WEBPACK_IMPORTED_MODULE_1__view_app_html___default.a.staticRenderFns,
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_0__controller_pym__["a" /* default */].init();
    }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_overview_html__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_overview_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_overview_html__);


/* harmony default export */ __webpack_exports__["a"] = ({
    render: __WEBPACK_IMPORTED_MODULE_0__view_overview_html___default.a.render,
    staticRenderFns: __WEBPACK_IMPORTED_MODULE_0__view_overview_html___default.a.staticRenderFns
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_people_html__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_people_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_people_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_people__ = __webpack_require__(0);



var COLORS = ['#FFCD2B', '#fc8d62', '#e78ac3', '#66c2a5',
// '#a6d854',
'#8da0cb'];

// const CATEGORIES = 

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pkg: {
                version: '0.2.9'
            },
            groups: []
        };
    },

    vuex: __WEBPACK_IMPORTED_MODULE_1__model_people__["a" /* default */],
    render: __WEBPACK_IMPORTED_MODULE_0__view_people_html___default.a.render,
    staticRenderFns: __WEBPACK_IMPORTED_MODULE_0__view_people_html___default.a.staticRenderFns,
    methods: {},
    mounted: function mounted() {
        var vm = this;

        var categories = ['A', 'B', 'C', 'D', 'E'];

        vm.groups = [{
            code: 'BDAC',
            name: 'Broadband Deployment Advisory Committee'
        }, {
            code: 'WG1',
            name: 'Competitive Access to Broadband Infrastructure'
        }, {
            code: 'WG2',
            name: 'Removing State and Local Regulatory Barriers'
        }, {
            code: 'WG3',
            name: 'Model Code for Municipalities'
        }, {
            code: 'WG4',
            name: 'Model Code for States'
        }].map(function (group) {
            group.people = [];
            return group;
        });

        var codes = vm.groups.map(function (group) {
            return group.code;
        });

        vm.people.map(function (person) {
            var category = person.Category.match(/ [A-E][1-9]/);

            if (category) {
                person.category = category[0].trim();
            } else {
                person.category = 'E';
            }

            if (person.category == 'A7') {
                person.category = 'E';
            }
            /*
                            if (person.category[0] == 'A' && person.category != 'A1') {
                                person.category = 'E';
                            }*/
            /*
                            if (person.category == 'D4') {
                                person.category = 'E';
                            }
            
                            if (person.Organization == 'National Grange') {
                                person.category = 'E';
                            }
            */
            person.color = COLORS[categories.indexOf(person.category[0])];

            return person;
        }).sort(function (a, b) {
            if (a.category < b.category) {
                return -1;
            } else if (a.category > b.category) {
                return 1;
            }
            return 0;
        }).map(function (person) {
            person.groups = person['Working Groups'].split(',').map(function (group) {
                return group.trim();
            }).filter(function (group) {
                return group !== '';
            });

            if (person.BDAC == 'TRUE') {
                person.groups.push('BDAC');
            }

            person.groups = person.groups.map(function (code) {
                return vm.groups[codes.indexOf(code)];
            });

            person.groups.forEach(function (group) {
                return group.people.push(person);
            });

            return person;
        });
    }
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(19);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));

//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1)))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.7.0
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also regiseter instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    data.props = resolveProps(route, matched.props && matched.props[name]);

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    'production' !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var val = extraQuery[key];
    parsedQuery[key] = Array.isArray(val) ? val.slice() : val;
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;
  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: location.query || {},
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var index$1 = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var index = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (index$1(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!index$1(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!index$1(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (index$1(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

index.parse = parse_1;
index.compile = compile_1;
index.tokensToFunction = tokensToFunction_1;
index.tokensToRegExp = tokensToRegExp_1;

/*  */

var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = index.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  var pathMap = oldPathMap || Object.create(null);
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var normalizedPath = normalizePath(path, parent);
  var pathToRegexpOptions = route.pathToRegexpOptions || {};

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = index(path, [], pathToRegexpOptions);
  if (false) {
    var keys = {};
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent) {
  path = path.replace(/\/$/, '');
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);
    if (!shouldScroll) {
      return
    }
    var isObject = typeof shouldScroll === 'object';
    if (isObject && typeof shouldScroll.selector === 'string') {
      var el = document.querySelector(shouldScroll.selector);
      if (el) {
        var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
        offset = normalizeOffset(offset);
        position = getElementPosition(el, offset);
      } else if (isValidPosition(shouldScroll)) {
        position = normalizePosition(shouldScroll);
      }
    } else if (isObject && isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }

    if (position) {
      window.scrollTo(position.x, position.y);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (resolvedDef.__esModule && resolvedDef.default) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          'production' !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    window.addEventListener('popstate', function (e) {
      var current = this$1.current;
      this$1.transitionTo(getLocation(this$1.base), function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    window.addEventListener('hashchange', function () {
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        replaceHash(route.fullPath);
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function pushHash (path) {
  window.location.hash = path;
}

function replaceHash (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  window.location.replace((base + "#" + path));
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: {} };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  'production' !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.7.0';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 13 */
/***/ (function(module, exports) {


    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"app fCCAdvisors"},[_c('overview')],1)}},
      staticRenderFns: []
    };
  

/***/ }),
/* 14 */
/***/ (function(module, exports) {


    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"overview"},[_c('h2',[_v("Who sits on the Broadband Deployment Advisory Committee?")]),_v(" "),_c('p',{staticStyle:{"line-height":"130%","padding-top":"5px","font-size":"16px","margin-bottom":"0","padding-bottom":"10px"}},[_v("Three out of every four of the 30 members on the BDAC work for telecommunications companies, trade organizations that represent them or think tanks that argue the same anti-regulatory positons. Only 10 percent of the members are from city or state government. Similar ratios are found on the four working groups, which will submit proposals to reduce local and state wireless regulations, which the BDAC will review and vote on.")]),_v(" "),_c('div',{staticClass:"overviewContainer"},[_c('router-view')],1)])}},
      staticRenderFns: []
    };
  

/***/ }),
/* 15 */
/***/ (function(module, exports) {


    module.exports = {
      render: function(){with(this){return _c('div',[_c('div',[_c('svg',{staticClass:"key",staticStyle:{"width":"252.4px","height":"62px"},attrs:{"viewBox":"0 0 252.4 62"}},[_c('circle',{staticStyle:{"fill":"#66C2A5","stroke":"#FFFFFF","stroke-miterlimit":"10"},attrs:{"cx":"131.6","cy":"15.2","r":"6.4"}}),_v(" "),_c('circle',{staticStyle:{"fill":"#FC8D62","stroke":"#FFFFFF","stroke-miterlimit":"10"},attrs:{"cx":"14.5","cy":"31.4","r":"6.4"}}),_v(" "),_c('circle',{staticStyle:{"fill":"#E78AC3","stroke":"#FFFFFF","stroke-miterlimit":"10"},attrs:{"cx":"14.5","cy":"48.8","r":"6.4"}}),_v(" "),_c('circle',{staticStyle:{"fill":"#A6D854","stroke":"#FFFFFF","stroke-miterlimit":"10"},attrs:{"cx":"380.8","cy":"132.9","r":"6.4"}}),_v(" "),_c('circle',{staticStyle:{"fill":"#FFD92F","stroke":"#FFFFFF","stroke-miterlimit":"10"},attrs:{"cx":"14.5","cy":"13.9","r":"6.4"}}),_v(" "),_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"390.8","y":"127","width":"71.2","height":"16.3"}}),_v(" "),_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"23.6","y":"8.5","width":"71.2","height":"16.3"}}),_v(" "),_c('text',{staticStyle:{"font-family":"tablet-gothic-n2,tablet-gothic,'Helvetica Neue',Helvetica,Arial,sans-serif","font-size":"14px"},attrs:{"transform":"matrix(1 0 0 1 23.6111 18.7575)"}},[_v("Telecom")]),_v(" "),_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"23.6","y":"24.6","width":"86.2","height":"16.3"}}),_v(" "),_c('text',{staticStyle:{"font-family":"tablet-gothic-n2,tablet-gothic,'Helvetica Neue',Helvetica,Arial,sans-serif","font-size":"14px"},attrs:{"transform":"matrix(1 0 0 1 23.6111 34.826)"}},[_v("Government")]),_v(" "),_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"141.1","y":"8.8","width":"108.2","height":"16.3"}}),_v(" "),_c('text',{attrs:{"transform":"matrix(1 0 0 1 141.1111 19.0431)"}},[_c('tspan',{staticStyle:{"font-family":"tablet-gothic-n2,tablet-gothic,'Helvetica Neue',Helvetica,Arial,sans-serif","font-size":"14px"},attrs:{"x":"0","y":"0"}},[_v("Membership orgs")])]),_v(" "),_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"24.6","y":"41.4","width":"85.2","height":"10.8"}}),_v(" "),_c('text',{staticStyle:{"font-family":"tablet-gothic-n2,tablet-gothic,'Helvetica Neue',Helvetica,Arial,sans-serif","font-size":"14px"},attrs:{"transform":"matrix(1 0 0 1 24.6111 51.6602)"}},[_v("Advocacy")]),_v(" "),_c('circle',{staticStyle:{"fill":"#8DA0CB","stroke":"#FFFFFF","stroke-miterlimit":"10"},attrs:{"cx":"131.6","cy":"31.8","r":"6.4"}}),_v(" "),_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"141.6","y":"26.4","width":"104.2","height":"10.8"}}),_v(" "),_c('text',{staticStyle:{"font-family":"tablet-gothic-n2,tablet-gothic,'Helvetica Neue',Helvetica,Arial,sans-serif","font-size":"14px"},attrs:{"transform":"matrix(1 0 0 1 141.6111 36.6777)"}},[_v("Other")])])]),_v(" "),_l((groups),function(group){return (group.code == 'BDAC')?_c('div',{class:'group ' + group.code},[_c('div',{staticClass:"people"},_l((group.people),function(person){return _c('div',{staticClass:"person"},[_c('div',{staticClass:"face"},[_c('div',{staticClass:"faceBox"},[_c('svg',{staticClass:"faceCanvas",attrs:{"viewBox":"0 0 100 100"}},[_c('defs',[_c('clipPath',{attrs:{"id":"circleClip"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"40"}})])]),_v(" "),_c('circle',{attrs:{"cx":"50","cy":"50","r":"49","fill":person.color}}),_v(" "),_c('circle',{attrs:{"cx":"50","cy":"50","r":"42","fill":"white"}}),_v(" "),(person.Photo !== '')?_c('image',{staticStyle:{"clip-path":"url(#circleClip)"},attrs:{"xlink:href":pkg.version + '/img/people/' + person.Photo,"x":"-32px","y":"-8px","height":"117.81px","width":"165px"}}):_e()])])]),_v(" "),_c('div',{staticClass:"company"},[_c('div',{staticClass:"description"},[_c('span',{staticClass:"companyName"},[_v(_s(person.Organization))]),_v(" "+_s(person.Description))]),_v(" "),_c('div',{staticClass:"name"},[(person['Alternate name'] !== '')?_c('span',{staticClass:"alternate"},[_v(_s(person['Alternate name'])),_c('span',{staticClass:"position"},[_v(", "+_s(person['Alternate position']))]),_v(" sitting in for ")]):_e(),_v(_s(person.Name)),_c('span',{staticClass:"position"},[_v(", "+_s(person.Position))])])])])}))]):_e()}),_v(" "),_c('div',{staticClass:"workingGroupsLabel"},[_v("WORKING GROUPS")]),_v(" "),_c('p',{staticClass:"workingGroupsExplanation"},[_v("Working group members are selected from BDAC members and other nominees.")]),_v(" "),_c('div',{staticClass:"workingGroups"},_l((groups),function(group){return (group.code != 'BDAC')?_c('div',{class:'group ' + group.code},[_c('h4',[_v(_s(group.name))]),_v(" "),_c('div',{staticClass:"people"},_l((group.people),function(person){return _c('div',{staticClass:"person"},[_c('svg',{attrs:{"width":"16","height":"16"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":person.color}})])])}))]):_e()}))],2)}},
      staticRenderFns: []
    };
  

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * Vue.js v2.4.2
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var _toString = Object.prototype.toString;

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(val);
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /([^-])([A-Z])/g;
var hyphenate = cached(function (str) {
  return str
    .replace(hyphenateRE, '$1-$2')
    .replace(hyphenateRE, '$1-$2')
    .toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */


/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: 'production' !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: 'production' !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

var emptyObject = Object.freeze({});

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

var warn = noop;
var tip = noop;
var formatComponentName = (null); // work around flow check

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var name = typeof vm === 'string'
      ? vm
      : typeof vm === 'function' && vm.options
        ? vm.options.name
        : vm._isVue
          ? vm.$options.name || vm.$options._componentTag
          : vm.name;

    var file = vm._isVue && vm.$options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  var generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

function handleError (err, vm, info) {
  if (config.errorHandler) {
    config.errorHandler.call(null, err, vm, info);
  } else {
    if (false) {
      warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
      console.error(err);
    } else {
      throw err
    }
  }
}

/*  */
/* globals MutationObserver */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefix has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

/**
 * Defer a task to execute it asynchronously.
 */
var nextTick = (function () {
  var callbacks = [];
  var pending = false;
  var timerFunc;

  function nextTickHandler () {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // the nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore if */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    var logError = function (err) { console.error(err); };
    timerFunc = function () {
      p.then(nextTickHandler).catch(logError);
      // in problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) { setTimeout(noop); }
    };
  } else if (typeof MutationObserver !== 'undefined' && (
    isNative(MutationObserver) ||
    // PhantomJS and iOS 7.x
    MutationObserver.toString() === '[object MutationObserverConstructor]'
  )) {
    // use MutationObserver where native Promise is not available,
    // e.g. PhantomJS IE11, iOS7, Android 4.4
    var counter = 1;
    var observer = new MutationObserver(nextTickHandler);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
  } else {
    // fallback to setTimeout
    /* istanbul ignore next */
    timerFunc = function () {
      setTimeout(nextTickHandler, 0);
    };
  }

  return function queueNextTick (cb, ctx) {
    var _resolve;
    callbacks.push(function () {
      if (cb) {
        try {
          cb.call(ctx);
        } catch (e) {
          handleError(e, ctx, 'nextTick');
        }
      } else if (_resolve) {
        _resolve(ctx);
      }
    });
    if (!pending) {
      pending = true;
      timerFunc();
    }
    if (!cb && typeof Promise !== 'undefined') {
      return new Promise(function (resolve, reject) {
        _resolve = resolve;
      })
    }
  }
})();

var _Set;
/* istanbul ignore if */
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */


var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid$1++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
]
.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value)) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
        }
        if (Array.isArray(value)) {
          dependArray(value);
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (hasOwn(target, key)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    'production' !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    'production' !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this) : parentVal
      )
    }
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm)
        : undefined;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      'production' !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn.call(this, parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (parentVal, childVal) {
  var res = Object.create(parentVal || null);
  return childVal
    ? extend(res, childVal)
    : res
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key in childVal) {
    var parent = ret[key];
    var child = childVal[key];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (parentVal, childVal) {
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    var lower = key.toLowerCase();
    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + key
      );
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options) {
  var inject = options.inject;
  if (Array.isArray(inject)) {
    var normalized = options.inject = {};
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = inject[i];
    }
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child);
  normalizeInject(child);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (false) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      'Invalid prop: type check failed for prop "' + name + '".' +
      ' Expected ' + expectedTypes.map(capitalize).join(', ') +
      ', got ' + Object.prototype.toString.call(value).slice(8, -1) + '.',
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    valid = typeof value === expectedType.toLowerCase();
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      "referenced during render. Make sure to declare reactive data " +
      "properties in the data option.",
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.functionalContext = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: {} };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.isCloned = true;
  return cloned
}

function cloneVNodes (vnodes) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i]);
  }
  return res
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, cur, old, event;
  for (name in on) {
    cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      'production' !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    last = res[res.length - 1];
    //  nested
    if (Array.isArray(c)) {
      res.push.apply(res, normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i)));
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        (last).text += String(c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[res.length - 1] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (comp.__esModule && comp.default) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      'production' !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && isDef(c.componentOptions)) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once$$1) {
  if (once$$1) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        this$1.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (arguments.length === 1) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  var defaultSlot = [];
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.functionalContext === context) &&
      child.data && child.data.slot != null
    ) {
      var name = child.data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children);
      } else {
        slot.push(child);
      }
    } else {
      defaultSlot.push(child);
    }
  }
  // ignore whitespace
  if (!defaultSlot.every(isWhitespace)) {
    slots.default = defaultSlot;
  }
  return slots
}

function isWhitespace (node) {
  return node.isComment || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure((name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure((name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  vm._watcher = new Watcher(vm, updateComponent, noop);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listensers hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data && parentVnode.data.attrs;
  vm.$listeners = listeners;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options
) {
  this.vm = vm;
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      'production' !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
var seenObjects = new _Set();
function traverse (val) {
  seenObjects.clear();
  _traverse(val, seenObjects);
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function checkOptionType (vm, name) {
  var option = vm.$options[name];
  if (!isPlainObject(option)) {
    warn(
      ("component option \"" + name + "\" should be an object."),
      vm
    );
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      if (isReservedAttribute(key) || config.isReservedAttr(key)) {
        warn(
          ("\"" + key + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    'production' !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      'production' !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  'production' !== 'production' && checkOptionType(vm, 'computed');
  var watchers = vm._computedWatchers = Object.create(null);

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }
    // create internal watcher for the computed property.
    watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (target, key, userDef) {
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = createComputedGetter(key);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  'production' !== 'production' && checkOptionType(vm, 'methods');
  var props = vm.$options.props;
  for (var key in methods) {
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
    if (false) {
      if (methods[key] == null) {
        warn(
          "method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
    }
  }
}

function initWatch (vm, watch) {
  'production' !== 'production' && checkOptionType(vm, 'watch');
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
        ? Reflect.ownKeys(inject)
        : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key];
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (false) {
        warn(("Injection \"" + key + "\" not found"), vm);
      }
    }
    return result
  }
}

/*  */

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  context,
  children
) {
  var props = {};
  var propOptions = Ctor.options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || {});
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var _context = Object.create(context);
  var h = function (a, b, c, d) { return createElement(_context, a, b, c, d, true); };
  var vnode = Ctor.options.render.call(null, h, {
    data: data,
    props: props,
    children: children,
    parent: context,
    listeners: data.on || {},
    injections: resolveInject(Ctor.options.inject, context),
    slots: function () { return resolveSlots(children, context); }
  });
  if (vnode instanceof VNode) {
    vnode.functionalContext = context;
    vnode.functionalOptions = Ctor.options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }
  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var vnodeComponentOptions = vnode.componentOptions;
  var options = {
    _isComponent: true,
    parent: parent,
    propsData: vnodeComponentOptions.propsData,
    _componentTag: vnodeComponentOptions.tag,
    _parentVnode: vnode,
    _parentListeners: vnodeComponentOptions.listeners,
    _renderChildren: vnodeComponentOptions.children,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnodeComponentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    'production' !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    warn(
      'Avoid using non-primitive value as key, ' +
      'use string/number value instead.',
      context
    );
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    return
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && isUndef(child.ns)) {
        applyNS(child, ns);
      }
    }
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      props = extend(extend({}, bindObject), props);
    }
    return scopedSlotFn(props) || fallback
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes && 'production' !== 'production') {
      slotNodes._rendered && warn(
        "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
        "- this will likely cause render errors.",
        this
      );
      slotNodes._rendered = true;
    }
    return slotNodes || fallback
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (Array.isArray(keyCodes)) {
    return keyCodes.indexOf(eventKeyCode) === -1
  } else {
    return keyCodes !== eventKeyCode
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      'production' !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var tree = this._staticTrees[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = this._staticTrees[index] =
    this.$options.staticRenderFns[index].call(this._renderProxy);
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      'production' !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(ours, existing) : ours;
      }
    }
  }
  return data
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null;
  var parentVnode = vm.$vnode = vm.$options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(vm.$options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;
  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', vm.$options._parentListeners, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs, null, true);
    defineReactive$$1(vm, '$listeners', vm.$options._parentListeners, null, true);
  }
}

function renderMixin (Vue) {
  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var staticRenderFns = ref.staticRenderFns;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // clone slot nodes on re-renders
      for (var key in vm.$slots) {
        vm.$slots[key] = cloneVNodes(vm.$slots[key]);
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    if (staticRenderFns && !vm._staticTrees) {
      vm._staticTrees = [];
    }
    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render function");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        vnode = vm.$options.renderError
          ? vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e)
          : vm._vnode;
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };

  // internal render helpers.
  // these are exposed on the instance prototype to reduce generated render
  // code size.
  Vue.prototype._o = markOnce;
  Vue.prototype._n = toNumber;
  Vue.prototype._s = toString;
  Vue.prototype._l = renderList;
  Vue.prototype._t = renderSlot;
  Vue.prototype._q = looseEqual;
  Vue.prototype._i = looseIndexOf;
  Vue.prototype._m = renderStatic;
  Vue.prototype._f = resolveFilter;
  Vue.prototype._k = checkKeyCodes;
  Vue.prototype._b = bindObjectProps;
  Vue.prototype._v = createTextVNode;
  Vue.prototype._e = createEmptyVNode;
  Vue.prototype._u = resolveScopedSlots;
  Vue.prototype._g = bindObjectListeners;
}

/*  */

var uid = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-init:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(((vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  opts.parent = options.parent;
  opts.propsData = options.propsData;
  opts._parentVnode = options._parentVnode;
  opts._parentListeners = options._parentListeners;
  opts._renderChildren = options._renderChildren;
  opts._componentTag = options._componentTag;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn(
          'Invalid component name: "' + name + '". Component names ' +
          'can only contain alphanumeric characters and the hyphen, ' +
          'and must start with a letter.'
        );
      }
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          if (type === 'component' && config.isReservedTag(id)) {
            warn(
              'Do not use built-in or reserved HTML elements as component ' +
              'id: ' + id
            );
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

var patternTypes = [String, RegExp, Array];

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (cache, current, filter) {
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        if (cachedNode !== current) {
          pruneCacheEntry(cachedNode);
        }
        cache[key] = null;
      }
    }
  }
}

function pruneCacheEntry (vnode) {
  if (vnode) {
    vnode.componentInstance.$destroy();
  }
}

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes
  },

  created: function created () {
    this.cache = Object.create(null);
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache[key]);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this.cache, this._vnode, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this.cache, this._vnode, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var vnode = getFirstComponentChild(this.$slots.default);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      if (name && (
        (this.include && !matches(this.include, name)) ||
        (this.exclude && matches(this.exclude, name))
      )) {
        return vnode
      }
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (this.cache[key]) {
        vnode.componentInstance = this.cache[key].componentInstance;
      } else {
        this.cache[key] = vnode;
      }
      vnode.data.keepAlive = true;
    }
    return vnode
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.4.2';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);



var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      'production' !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *

/*
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

// Some browsers do not support dynamically changing type for <input>
// so they need to be treated as different nodes
function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  var inPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          inPre++;
        }
        if (
          !inPre &&
          !vnode.ns &&
          !(config.ignoredElements.length && config.ignoredElements.indexOf(tag) > -1) &&
          config.isUnknownElement(tag)
        ) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        inPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    var ancestor = vnode;
    while (ancestor) {
      if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
        nodeOps.setAttribute(vnode.elm, i, '');
      }
      ancestor = ancestor.parent;
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, elmToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : null;
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          newStartVnode = newCh[++newStartIdx];
        } else {
          elmToMove = oldCh[idxInOld];
          /* istanbul ignore if */
          if (false) {
            warn(
              'It seems there are duplicate keys that is causing an update error. ' +
              'Make sure each v-for item has a unique key.'
            );
          }
          if (sameVnode(elmToMove, newStartVnode)) {
            patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
            newStartVnode = newCh[++newStartIdx];
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
            newStartVnode = newCh[++newStartIdx];
          }
        }
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var bailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue) {
    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.elm = elm;
      vnode.isAsyncPlaceholder = true;
      return true
    }
    if (false) {
      if (!assertNodeMatch(elm, vnode)) {
        return false
      }
    }
    vnode.elm = elm;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          var childrenMatch = true;
          var childNode = elm.firstChild;
          for (var i$1 = 0; i$1 < children.length; i$1++) {
            if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
              childrenMatch = false;
              break
            }
            childNode = childNode.nextSibling;
          }
          // if childNode is not null, it means the actual childNodes list is
          // longer than the virtual children list.
          if (!childrenMatch || childNode) {
            if (false
            ) {
              bailed = true;
              console.warn('Parent: ', elm);
              console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
            }
            return false
          }
        }
      }
      if (isDef(data)) {
        for (var key in data) {
          if (!isRenderedModule(key)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode) {
    if (isDef(vnode.tag)) {
      return (
        vnode.tag.indexOf('vue-component') === 0 ||
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }
        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        if (isDef(vnode.parent)) {
          // component root element replaced.
          // update parent placeholder node element, recursively
          var ancestor = vnode.parent;
          while (ancestor) {
            ancestor.elm = vnode.elm;
            ancestor = ancestor.parent;
          }
          if (isPatchable(vnode)) {
            for (var i = 0; i < cbs.create.length; ++i) {
              cbs.create[i](emptyNode, vnode.parent);
            }
          }
        }

        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  /* istanbul ignore if */
  if (isIE9 && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, key);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;



function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

/*  */

/**
 * Cross-platform code generation for component v-model
 */


/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */


/**
 * parse directive model to do the array update transform. a[idx] = val => $$a.splice($$idx, 1, val)
 *
 * for loop possible cases:
 *
 * - test
 * - test[idx]
 * - test[test1[idx]]
 * - test["a"][idx]
 * - xxx.test[a[a].test1[idx]]
 * - test.xxx.a["asa"][test1[idx]]
 *
 */

var str;
var index$1;

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  var event;
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    // Chrome fires microtasks in between click/change, leads to #4521
    event = isChrome ? 'click' : 'change';
    on[event] = [].concat(on[CHECKBOX_RADIO_TOKEN], on[event] || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  if (once$$1) {
    var oldHandler = handler;
    var _target = target$1; // save current target element in closure
    handler = function (ev) {
      var res = arguments.length === 1
        ? oldHandler(ev)
        : oldHandler.apply(null, arguments);
      if (res !== null) {
        remove$2(event, handler, capture, _target);
      }
    };
  }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(event, handler, capture);
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, vnode, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (
  elm,
  vnode,
  checkVal
) {
  return (!elm.composing && (
    vnode.tag === 'option' ||
    isDirty(elm, checkVal) ||
    isInputChanged(elm, checkVal)
  ))
}

function isDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isInputChanged (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers) && modifiers.number) {
    return toNumber(value) !== toNumber(newVal)
  }
  if (isDef(modifiers) && modifiers.trim) {
    return value.trim() !== newVal.trim()
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likley wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser && window.requestAnimationFrame
  ? window.requestAnimationFrame.bind(window)
  : setTimeout;

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var model$1 = {
  inserted: function inserted (el, binding, vnode) {
    if (vnode.tag === 'select') {
      var cb = function () {
        setSelected(el, binding, vnode.context);
      };
      cb();
      /* istanbul ignore if */
      if (isIE || isEdge) {
        setTimeout(cb, 0);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },
  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        trigger(el, 'change');
      }
    }
  }
};

function setSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    'production' !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: model$1,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$options._renderChildren;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild && (oldChild.data.transition = extend({}, data));
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    var body = document.body;
    var f = body.offsetHeight; // eslint-disable-line

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
setTimeout(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

/* harmony default export */ __webpack_exports__["a"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Vuex v1.0.1
 * (c) 2017 Evan You
 * Released under the MIT License.
 */
(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Vuex = factory());
}(this, (function () { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * Merge an array of objects into one.
 *
 * @param {Array<Object>} arr
 * @return {Object}
 */

function mergeObjects(arr) {
  return arr.reduce(function (prev, obj) {
    Object.keys(obj).forEach(function (key) {
      var existing = prev[key];
      if (existing) {
        // allow multiple mutation objects to contain duplicate
        // handlers for the same mutation type
        if (Array.isArray(existing)) {
          prev[key] = existing.concat(obj[key]);
        } else {
          prev[key] = [existing].concat(obj[key]);
        }
      } else {
        prev[key] = obj[key];
      }
    });
    return prev;
  }, {});
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * Check whether the given value is Object or not
 *
 * @param {*} obj
 * @return {Boolean}
 */

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

/**
 * Get state sub tree by given keys.
 *
 * @param {Object} state
 * @param {Array<String>} nestedKeys
 * @return {Object}
 */
function getNestedState(state, nestedKeys) {
  return nestedKeys.reduce(function (state, key) {
    return state[key];
  }, state);
}

/**
 * Hacks to get access to Vue internals.
 * Maybe we should expose these...
 */

var Watcher = void 0;
function getWatcher(vm) {
  if (!Watcher) {
    var noop = function noop() {};
    var unwatch = vm.$watch(noop, noop);
    Watcher = vm._watchers[0].constructor;
    unwatch();
  }
  return Watcher;
}

var Dep = void 0;
function getDep(vm) {
  if (!Dep) {
    Dep = vm._data.__ob__.dep.constructor;
  }
  return Dep;
}

var hook = typeof window !== 'undefined' && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin(store) {
  if (!hook) return;

  hook.emit('vuex:init', store);

  hook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    hook.emit('vuex:mutation', mutation, state);
  });
}

var override = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    var usesInit = Vue.config._lifecycleHooks.indexOf('init') > -1;
    Vue.mixin(usesInit ? { init: vuexInit } : { beforeCreate: vuexInit });
  } else {
    (function () {
      // override init and inject vuex init procedure
      // for 1.x backwards compatibility.
      var _init = Vue.prototype._init;
      Vue.prototype._init = function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;
        _init.call(this, options);
      };
    })();
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit() {
    var options = this.$options;
    var store = options.store,
        vuex = options.vuex;
    // store injection

    if (store) {
      this.$store = store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
    // vuex option handling
    if (vuex) {
      if (!this.$store) {
        console.warn('[vuex] store not injected. make sure to ' + 'provide the store option in your root component.');
      }
      var state = vuex.state,
          actions = vuex.actions;
      var getters = vuex.getters;
      // handle deprecated state option

      if (state && !getters) {
        console.warn('[vuex] vuex.state option will been deprecated in 1.0. ' + 'Use vuex.getters instead.');
        getters = state;
      }
      // getters
      if (getters) {
        options.computed = options.computed || {};
        for (var key in getters) {
          defineVuexGetter(this, key, getters[key]);
        }
      }
      // actions
      if (actions) {
        options.methods = options.methods || {};
        for (var _key in actions) {
          options.methods[_key] = makeBoundAction(this.$store, actions[_key], _key);
        }
      }
    }
  }

  /**
   * Setter for all getter properties.
   */

  function setter() {
    throw new Error('vuex getter properties are read-only.');
  }

  /**
   * Define a Vuex getter on an instance.
   *
   * @param {Vue} vm
   * @param {String} key
   * @param {Function} getter
   */

  function defineVuexGetter(vm, key, getter) {
    if (typeof getter !== 'function') {
      console.warn('[vuex] Getter bound to key \'vuex.getters.' + key + '\' is not a function.');
    } else {
      Object.defineProperty(vm, key, {
        enumerable: true,
        configurable: true,
        get: makeComputedGetter(vm.$store, getter),
        set: setter
      });
    }
  }

  /**
   * Make a computed getter, using the same caching mechanism of computed
   * properties. In addition, it is cached on the raw getter function using
   * the store's unique cache id. This makes the same getter shared
   * across all components use the same underlying watcher, and makes
   * the getter evaluated only once during every flush.
   *
   * @param {Store} store
   * @param {Function} getter
   */

  function makeComputedGetter(store, getter) {
    var id = store._getterCacheId;

    // cached
    if (getter[id]) {
      return getter[id];
    }
    var vm = store._vm;
    var Watcher = getWatcher(vm);
    var Dep = getDep(vm);
    var watcher = new Watcher(vm, function (vm) {
      return getter(vm.state);
    }, null, { lazy: true });
    var computedGetter = function computedGetter() {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    };
    getter[id] = computedGetter;
    return computedGetter;
  }

  /**
   * Make a bound-to-store version of a raw action function.
   *
   * @param {Store} store
   * @param {Function} action
   * @param {String} key
   */

  function makeBoundAction(store, action, key) {
    if (typeof action !== 'function') {
      console.warn('[vuex] Action bound to key \'vuex.actions.' + key + '\' is not a function.');
    }
    return function vuexBoundAction() {
      for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return action.call.apply(action, [this, store].concat(args));
    };
  }

  // option merging
  var merge = Vue.config.optionMergeStrategies.computed;
  Vue.config.optionMergeStrategies.vuex = function (toVal, fromVal) {
    if (!toVal) return fromVal;
    if (!fromVal) return toVal;
    return {
      getters: merge(toVal.getters, fromVal.getters),
      state: merge(toVal.state, fromVal.state),
      actions: merge(toVal.actions, fromVal.actions)
    };
  };
};

var Vue = void 0;
var uid = 0;

var Store = function () {

  /**
   * @param {Object} options
   *        - {Object} state
   *        - {Object} actions
   *        - {Object} mutations
   *        - {Array} plugins
   *        - {Boolean} strict
   */

  function Store() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$state = _ref.state,
        state = _ref$state === undefined ? {} : _ref$state,
        _ref$mutations = _ref.mutations,
        mutations = _ref$mutations === undefined ? {} : _ref$mutations,
        _ref$modules = _ref.modules,
        modules = _ref$modules === undefined ? {} : _ref$modules,
        _ref$plugins = _ref.plugins,
        plugins = _ref$plugins === undefined ? [] : _ref$plugins,
        _ref$strict = _ref.strict,
        strict = _ref$strict === undefined ? false : _ref$strict;

    classCallCheck(this, Store);

    this._getterCacheId = 'vuex_store_' + uid++;
    this._dispatching = false;
    this._rootMutations = this._mutations = mutations;
    this._modules = modules;
    this._subscribers = [];
    // bind dispatch to self
    var dispatch = this.dispatch;
    this.dispatch = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      dispatch.apply(_this, args);
    };
    // use a Vue instance to store the state tree
    // suppress warnings just in case the user has added
    // some funky global mixins
    if (!Vue) {
      throw new Error('[vuex] must call Vue.use(Vuex) before creating a store instance.');
    }
    var silent = Vue.config.silent;
    Vue.config.silent = true;
    this._vm = new Vue({
      data: {
        state: state
      }
    });
    Vue.config.silent = silent;
    this._setupModuleState(state, modules);
    this._setupModuleMutations(modules);
    // add extra warnings in strict mode
    if (strict) {
      this._setupMutationCheck();
    }
    // apply plugins
    devtoolPlugin(this);
    plugins.forEach(function (plugin) {
      return plugin(_this);
    });
  }

  /**
   * Getter for the entire state tree.
   * Read only.
   *
   * @return {Object}
   */

  createClass(Store, [{
    key: 'replaceState',


    /**
     * Replace root state.
     *
     * @param {Object} state
     */

    value: function replaceState(state) {
      this._dispatching = true;
      this._vm.state = state;
      this._dispatching = false;
    }

    /**
     * Dispatch an action.
     *
     * @param {String} type
     */

  }, {
    key: 'dispatch',
    value: function dispatch(type) {
      var _this2 = this;

      for (var _len2 = arguments.length, payload = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        payload[_key2 - 1] = arguments[_key2];
      }

      var silent = false;
      var isObjectStyleDispatch = false;
      // compatibility for object actions, e.g. FSA
      if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' && type.type && arguments.length === 1) {
        isObjectStyleDispatch = true;
        payload = type;
        if (type.silent) silent = true;
        type = type.type;
      }
      var handler = this._mutations[type];
      var state = this.state;
      if (handler) {
        this._dispatching = true;
        // apply the mutation
        if (Array.isArray(handler)) {
          handler.forEach(function (h) {
            isObjectStyleDispatch ? h(state, payload) : h.apply(undefined, [state].concat(toConsumableArray(payload)));
          });
        } else {
          isObjectStyleDispatch ? handler(state, payload) : handler.apply(undefined, [state].concat(toConsumableArray(payload)));
        }
        this._dispatching = false;
        if (!silent) {
          (function () {
            var mutation = isObjectStyleDispatch ? payload : { type: type, payload: payload };
            _this2._subscribers.forEach(function (sub) {
              return sub(mutation, state);
            });
          })();
        }
      } else {
        console.warn('[vuex] Unknown mutation: ' + type);
      }
    }

    /**
     * Watch state changes on the store.
     * Same API as Vue's $watch, except when watching a function,
     * the function gets the state as the first argument.
     *
     * @param {Function} fn
     * @param {Function} cb
     * @param {Object} [options]
     */

  }, {
    key: 'watch',
    value: function watch(fn, cb, options) {
      var _this3 = this;

      if (typeof fn !== 'function') {
        console.error('Vuex store.watch only accepts function.');
        return;
      }
      return this._vm.$watch(function () {
        return fn(_this3.state);
      }, cb, options);
    }

    /**
     * Subscribe to state changes. Fires after every mutation.
     */

  }, {
    key: 'subscribe',
    value: function subscribe(fn) {
      var subs = this._subscribers;
      if (subs.indexOf(fn) < 0) {
        subs.push(fn);
      }
      return function () {
        var i = subs.indexOf(fn);
        if (i > -1) {
          subs.splice(i, 1);
        }
      };
    }

    /**
     * Hot update mutations & modules.
     *
     * @param {Object} options
     *        - {Object} [mutations]
     *        - {Object} [modules]
     */

  }, {
    key: 'hotUpdate',
    value: function hotUpdate() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          mutations = _ref2.mutations,
          modules = _ref2.modules;

      this._rootMutations = this._mutations = mutations || this._rootMutations;
      this._setupModuleMutations(modules || this._modules);
    }

    /**
     * Attach sub state tree of each module to the root tree.
     *
     * @param {Object} state
     * @param {Object} modules
     */

  }, {
    key: '_setupModuleState',
    value: function _setupModuleState(state, modules) {
      var _this4 = this;

      if (!isObject(modules)) return;

      Object.keys(modules).forEach(function (key) {
        var module = modules[key];

        // set this module's state
        Vue.set(state, key, module.state || {});

        // retrieve nested modules
        _this4._setupModuleState(state[key], module.modules);
      });
    }

    /**
     * Bind mutations for each module to its sub tree and
     * merge them all into one final mutations map.
     *
     * @param {Object} updatedModules
     */

  }, {
    key: '_setupModuleMutations',
    value: function _setupModuleMutations(updatedModules) {
      var modules = this._modules;
      Object.keys(updatedModules).forEach(function (key) {
        modules[key] = updatedModules[key];
      });
      var updatedMutations = this._createModuleMutations(modules, []);
      this._mutations = mergeObjects([this._rootMutations].concat(toConsumableArray(updatedMutations)));
    }

    /**
     * Helper method for _setupModuleMutations.
     * The method retrieve nested sub modules and
     * bind each mutations to its sub tree recursively.
     *
     * @param {Object} modules
     * @param {Array<String>} nestedKeys
     * @return {Array<Object>}
     */

  }, {
    key: '_createModuleMutations',
    value: function _createModuleMutations(modules, nestedKeys) {
      var _this5 = this;

      if (!isObject(modules)) return [];

      return Object.keys(modules).map(function (key) {
        var module = modules[key];
        var newNestedKeys = nestedKeys.concat(key);

        // retrieve nested modules
        var nestedMutations = _this5._createModuleMutations(module.modules, newNestedKeys);

        if (!module || !module.mutations) {
          return mergeObjects(nestedMutations);
        }

        // bind mutations to sub state tree
        var mutations = {};
        Object.keys(module.mutations).forEach(function (name) {
          var original = module.mutations[name];
          mutations[name] = function (state) {
            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              args[_key3 - 1] = arguments[_key3];
            }

            original.apply(undefined, [getNestedState(state, newNestedKeys)].concat(args));
          };
        });

        // merge mutations of this module and nested modules
        return mergeObjects([mutations].concat(toConsumableArray(nestedMutations)));
      });
    }

    /**
     * Setup mutation check: if the Vuex instance's state is mutated
     * outside of a mutation handler, we throw en error. This effectively
     * enforces all mutations to the state to be trackable and hot-reloadable.
     * However, this comes at a run time cost since we are doing a deep
     * watch on the entire state tree, so it is only enabled if the
     * strict option is set to true.
     */

  }, {
    key: '_setupMutationCheck',
    value: function _setupMutationCheck() {
      var _this6 = this;

      var Watcher = getWatcher(this._vm);
      /* eslint-disable no-new */
      new Watcher(this._vm, 'state', function () {
        if (!_this6._dispatching) {
          throw new Error('[vuex] Do not mutate vuex store state outside mutation handlers.');
        }
      }, { deep: true, sync: true });
      /* eslint-enable no-new */
    }
  }, {
    key: 'state',
    get: function get$$1() {
      return this._vm.state;
    },
    set: function set$$1(v) {
      throw new Error('[vuex] Use store.replaceState() to explicit replace store state.');
    }
  }]);
  return Store;
}();

function install(_Vue) {
  if (Vue) {
    console.warn('[vuex] already installed. Vue.use(Vuex) should be called only once.');
    return;
  }
  Vue = _Vue;
  override(Vue);
}

// auto install in dist mode
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

var index = {
  Store: Store,
  install: install
};

return index;

})));


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {"people":[{"Name":"Allen Bell","Position":"Joint Use and Franchise Manager","Organization":"Georgia Power/Southern Co.","Alternate name":"","Alternate position":"","Photo":"Allen Bell.jpg","Description":"owns Southern Telecom, a broadband provider.","Recommendations":"Phillip Moeller, Edison Electric Institute; Brett Kilbourne, Utilities Telecom Council","Nominated By":"Leslie Sibert, VP, Distribution, Georgia Power","Category":"Business (power company) A2","Working Groups":"WG1, WG4","BDAC":"TRUE"},{"Name":"Andy Huckaba","Position":"City Councilman","Organization":"City of Lenexa, Kansas","Alternate name":"","Alternate position":"","Photo":"Andy Huckaba.jpg","Description":"became the second city to gain a seat on the BDAC, however, Huckaba is a management consultant whose clients include telecommunications companies such as Sprint.","Recommendations":"","Nominated By":"","Category":"Government - B2","Working Groups":"","BDAC":"TRUE"},{"Name":"Betsy Huber","Position":"President","Organization":"National Grange","Alternate name":"","Alternate position":"","Photo":"Betsy Huber.jpg","Description":"is an agricultural advocacy group represented by Huber, who has appeared at high-profile events with FCC Chairman Ajit Pai and is supportive of his anti-regulatory agenda.","Recommendations":"Rep. Costello (PA); Roslyn Layton","Nominated By":"Phil Prelli, Chairman of the Board, The National Grange;","Category":"Membership organization (fraternal organization, membership organization, reps agriculture interests, right-leaning, advc. group) D1","Working Groups":"WG4","BDAC":"TRUE"},{"Name":"Brent Skorup","Position":"Research Fellow, Technology Policy Program","Organization":"Mercatus Center, George Mason University","Alternate name":"","Alternate position":"","Photo":"Brent Skorup.jpg","Description":"is a conservative, free-market think tank represented by Skorup, whose articles criticizing FCC regulations have appeared in national media.","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (academia)","Working Groups":"WG1","BDAC":"TRUE"},{"Name":"Brian Mefford","Position":"Founder & CEO","Organization":"Connected Nation Exchange","Alternate name":"Angela Stacy","Alternate position":"VP, Marketing and Communications,","Photo":"Angela Stacy.jpg","Description":"operates a software platform for cities and providers that lease public assets.","Recommendations":"Rep. Guthrie (KY); Sen. McConnell (KY)","Nominated By":"Self-nominated","Category":"Business A1","Working Groups":"WG3, WG4","BDAC":"TRUE"},{"Name":"Carlos Gutierrez","Position":"Deputy Director, Legal & Policy Affairs","Organization":"LGBT Technology Partnership & Institute","Alternate name":"","Alternate position":"","Photo":"Carlos Gutierrez.jpg","Description":"is a group of LGBT organizations and tech companies; critical of Pai’s proposals to remove net neutrality and other regulations.","Recommendations":"","Nominated By":"Chris Wood, Exec. Director, LGBT Tech. Partnership & Inst.","Category":"Advocacy (nonprofit management - LGBT) C1","Working Groups":"WG2, WG4","BDAC":"TRUE"},{"Name":"Chris Bondurant","Position":"Assistant VP, Construction & Engineering Operations","Organization":"AT&T Inc.","Alternate name":"","Alternate position":"","Photo":"Chris Bondurant.jpg","Description":"is the second-largest wireless provider in the United States; Bondurant said AT&T spends billions of dollars annually on local permitting fees.","Recommendations":"","Nominated By":"Joan Marsh, Senior VP, AT&T","Category":"Business (telecommunications or provider) A1","Working Groups":"WG1, WG3","BDAC":"TRUE"},{"Name":"Christopher Yoo","Position":"Professor of Law, Univ. of Pennsylvania","Organization":"University of Pennsylvania","Alternate name":"","Alternate position":"","Photo":"Christopher S. Yoo.jpg","Description":"is where Yoo conducts research that typically argues against telecommunications regulations; he is critical of municipal-run networks.","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (academia – conservative)","Working Groups":"WG1, WG4","BDAC":"TRUE"},{"Name":"David Don","Position":"VP, Regulatory Policy","Organization":"Comcast Corp.","Alternate name":"","Alternate position":"","Photo":"David Don.jpg","Description":"is the largest internet provider in the United States, launched a wireless service this year and is feuding with Vermont over permitting.","Recommendations":"","Nominated By":"Kathryn A. Zachem, Senior Vice President, Regulatory and State Legislative Affairs, Comcast Corp.","Category":"Business (telecommunications or provider) A1","Working Groups":"WG1, WG4","BDAC":"TRUE"},{"Name":"Douglas Dimitroff","Position":"Telecommunications Practice Team Leader, Phillips Lytle LLP","Organization":"New York State Wireless Association","Alternate name":"","Alternate position":"","Photo":"Douglas Dimitroff.jpg","Description":"board members include T-Mobile, Crown Castle and AT&T.","Recommendations":"","Nominated By":"Johon Schmidt, Partner, Phillips Lytle; Christopher Fisher (NYSWA)","Category":"Association (*Is this a nonprofit? –– .org) D1*","Working Groups":"WG3","BDAC":"TRUE"},{"Name":"Elizabeth Bowles","Position":"President","Organization":"Aristotle Inc.","Alternate name":"","Alternate position":"","Photo":"Elizabeth Bowles.jpg","Description":"is a regional internet provider in central Arkansas; Bowles said she believes it’s a “fundamental right” for all Americans to have high-speed internet access.","Recommendations":"Reps. Hill and Crawford and Sen. Cotton (Ark.)","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"WG2, WG4","BDAC":"TRUE"},{"Name":"Elizabeth Pierce","Position":"CEO","Organization":"Quintillion Networks LLC","Alternate name":"","Alternate position":"","Photo":"Elizabeth Pierce.jpg","Description":"is an internet provider in Alaska; Pierce said the permitting process in Alaska took longer than building fiber cables from scratch and shipping them from Europe.","Recommendations":"Cheryl Stine, Arctic Slope Regional Corporation; Tom Begich, AK State Senator; Chris Birch, AK State Rep.; Chuck Kopp, AK State Rep.","Nominated By":"Kristina Woolston, VP, Quintillion","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":"TRUE"},{"Name":"Geoffrey Manne","Position":"Executive Director","Organization":"The International Center for Law & Economics","Alternate name":"Allen Gibby","Alternate position":"Senior Fellow, Law & Economics,","Photo":"Allen Gibby.jpg","Description":"is a right-leaning think tank that typically opposes FCC regulations. Manne said he is critical of “governments that make it harder for [people] to build things.”","Recommendations":"","Nominated By":"Jennifer McLean, Dir. Of Operations, ICLE","Category":"Other (academia – conservative)","Working Groups":"WG1, WG3","BDAC":"TRUE"},{"Name":"Jaime Fink","Position":"Co-Founder","Organization":"Mimosa Networks Inc.","Alternate name":"","Alternate position":"","Photo":"Jaime Fink.jpg","Description":"is a startup that provides wireless broadband internet access; Fink said most of his time is spent educating cities and utility companies on wireless infrastructure.","Recommendations":"","Nominated By":"Brian L. Hinman, CEO, Mimosa Networks","Category":"Business (telecommunications company – startup) A1","Working Groups":"WG3, WG4","BDAC":"TRUE"},{"Name":"Jim Matheson","Position":"CEO","Organization":"National Rural Electric Cooperative Association","Alternate name":"Martha Duggan","Alternate position":"Senior Director, Regulatory Affairs,","Photo":"Martha Duggan.jpg","Description":"is a national organization for more than 900 not-for-profit rural electric cooperatives and public power districts.","Recommendations":"Derrick Moe, Minn. Rural Elec. Assoc.; Tom VanParis, Indiana Elec. Coops.; Chris Meyers, OK Assoc. of Elec. Coops; Keven Groenewold, NM RECA; Joe Brannan, NC Elec. Coops; Bill Willingham, FL Elec. Coops. Assoc.; Doug Snitgen, Mich. Elec. Coops; Richard Johnstone, VA MD and DE Assoc. of Elec. Coops.","Nominated By":"Martha Duggan, Senior Director, Regulatory Affairs, NRECA","Category":"Association (nonprofit management) D1","Working Groups":"WG1, WG3","BDAC":"TRUE"},{"Name":"John Saw","Position":"Chief Technology Officer","Organization":"Sprint Corp.","Alternate name":"Charles McKee","Alternate position":"VP, Government Affairs Federal and State Regulatory,","Photo":"Charles McKee.jpg","Description":"is the fourth-largest U.S. wireless carrier; Saw said standard city regulations would make buildouts more predictable.","Recommendations":"","Nominated By":"Charles W. McKee, VP of Govrnment Affairs, Sprint","Category":"Business (telecommunications or provider) A1","Working Groups":"WG2","BDAC":"TRUE"},{"Name":"Jonathan Adelstein","Position":"CEO","Organization":"Wireless Infrastructure Association","Alternate name":"","Alternate position":"","Photo":"Jonathan Adelstein.jpg","Description":"has as members telecommunications companies such as AT&T, Verizon Wireless, T-Mobile and many others. ","Recommendations":"","Nominated By":"","Category":"Association D1*","Working Groups":"","BDAC":"TRUE"},{"Name":"Karen Charles Peterson","Position":"Commissioner, Massachusetts Dept. of Telecommunications and Cable","Organization":"National Association of Regulatory Utility Commissioners","Alternate name":"","Alternate position":"","Photo":"Karen Charles Peterson.jpg","Description":"represents state public service commissions that regulate utility companies.","Recommendations":"","Nominated By":"Robert F. Powelson, NARUC President (and Commissioner, Pennsylvania PUC)","Category":"Association - D1","Working Groups":"WG1, WG4","BDAC":"TRUE"},{"Name":"Kelleigh Cole","Position":"Director, Broadband Outreach Center","Organization":"Utah Governor's Office of Economic Development","Alternate name":"","Alternate position":"","Photo":"Kelleigh Cole.jpg","Description":"works with broadband providers and policymakers to expand internet deployment and usage.","Recommendations":"Sens. Lee and Hatch (UT); Ray Timothy, UETN","Nominated By":"Q. Val Hale, Executive Director, Utah Governor's Office of Economic Development","Category":"Government - state program, dep. of economic development) B3","Working Groups":"WG4","BDAC":"TRUE"},{"Name":"Kelly McGriff","Position":"General Counsel","Organization":"Southern Light (Uniti Fiber Inc.)","Alternate name":"","Alternate position":"","Photo":"Kelly McGriff.jpg","Description":"is an internet provider in the Gulf Coast and sells data transport solutions to carriers and government.","Recommendations":"","Nominated By":"Andy Newton, President & CEO, Southern Light","Category":"Business (telecommunications or provider) A1","Working Groups":"WG4","BDAC":"TRUE"},{"Name":"Ken Simon","Position":"General Counsel","Organization":"Crown Castle International Corp.","Alternate name":"Monica Gambino","Alternate position":"VP, Legal,","Photo":"Monica Gambino.jpg","Description":"is the nation's largest provider of wireless infrastructure; involved in lawsuits against cities for withholding permits.","Recommendations":"Cinnamon Rogers, TIA; Jonathan Adelstein, WIA","Nominated By":"Jay Brown, President and CEO, Crown Castle","Category":"Business (telecommunications or provider) A1","Working Groups":"WG1","BDAC":"TRUE"},{"Name":"Kim Keenan","Position":"President & CEO","Organization":"Multicultural Media, Telecom and Internet Council","Alternate name":"","Alternate position":"","Photo":"Kim Keenan.jpg","Description":"is a nonpartisan advocacy group funded in part by telecommunications and broadcast companies.","Recommendations":"Rep. Clarke (NY); Fmr. Rep. Stearns (FL); Jane Cabarrus, Northampton Co. Branch, NAACP","Nominated By":"Julia Johnson, Chair of the Board, MMTC","Category":"Advocacy (multicultural interests in media) C1","Working Groups":"WG2, WG3","BDAC":"TRUE"},{"Name":"Larry Thompson","Position":"CEO, Vantage Point Solutions Inc.","Organization":"National Exchange Carrier Association","Alternate name":"","Alternate position":"","Photo":"Larry D. Thompson.jpg","Description":"is a nonprofit group whose members include AT&T, CenturyLink and regional internet providers. Vantage Point joined NECA in lobbying the FCC in the past.","Recommendations":"Sen. Thune (SD)","Nominated By":"Self-nominated (Vantage Point Solutions); Jim Frame (NECA)","Category":"Association (nonprofit - concerned with rural connectivity, expanding access) D1*","Working Groups":"WG3","BDAC":"TRUE"},{"Name":"Marc Ganzi","Position":"CEO, Co-founder, Digital Bridge Holdings LLC","Organization":"ExteNet Systems Inc.","Alternate name":"Anthony Lehv","Alternate position":"General Counsel,","Photo":"Anthony Lehv.jpg","Description":"operates networks that support nationwide U.S. mobile carriers.","Recommendations":"","Nominated By":"Self-nominated (Digital Bridge); Russ Manire (ExteNet Systems); Alex Gellman (Vertical Bridge Holdings)","Category":"Business (telecommunications or provider) A1","Working Groups":"WG2, WG3","BDAC":"TRUE"},{"Name":"Marc Hudson","Position":"CEO & Co-Founder","Organization":"Rocket Fiber LLC","Alternate name":"","Alternate position":"","Photo":"Marc Hudson.jpg","Description":"is a broadband startup in Detroit; Hudson considers easing broadband regulation but is concerned about the digital divide in Detroit.","Recommendations":"","Nominated By":"Edi Demaj, COO, Rocket Fiber","Category":"Business (telecommunications or provider – startup) A1","Working Groups":"WG2, WG3","BDAC":"TRUE"},{"Name":"Michael Hain","Position":"General Manager & Chief Technology Officer","Organization":"Nittany Media Inc.","Alternate name":"","Alternate position":"","Photo":"Michael Hain.jpg","Description":"is a small-town internet provider; Hain said he was “thrilled” that Pai and BDAC were “pro-making-things-happen.”","Recommendations":"Rep. Thompson (PA); Brian Barno, Broadband Cable Assoc. of PA","Nominated By":"Paul L Rudy, Jr., County Commissioner, Perry County; Adam Harris, State Representative, 82nd Legislative District, Commonwealth of Pennsylvania","Category":"Business (telecommunications or provider – smalltown, pro-regulation) A1","Working Groups":"WG2, WG4","BDAC":"TRUE"},{"Name":"Milo Medin","Position":"VP, Access Services","Organization":"Alphabet (Google Fiber)","Alternate name":"Megan Stull","Alternate position":"Counsel,","Photo":"Megan Stull.jpg","Description":"offers super-fast internet service in 10 cities.","Recommendations":"","Nominated By":"John Burchett, Head of Public Policy for Google Access and Google Fiber.","Category":"Business (telecommunications or provider*) A1","Working Groups":"WG1, WG3","BDAC":"TRUE"},{"Name":"Robert DeBroux","Position":"Director, Public Policy and Federal Regulatory Affairs","Organization":"TDS Telecom Inc.","Alternate name":"","Alternate position":"","Photo":"Robert DeBroux.jpg","Description":"is an internet provider and the seventh-largest local exchange telephone company in the United States.","Recommendations":"Sens. Baldwin and Johnson (WI); Derrick Owens, WTA;","Nominated By":"Kevin G. .Hess, Executive Vice President, TDS","Category":"Business (telecommunications or provider) A1","Working Groups":"WG2","BDAC":"TRUE"},{"Name":"Sam Liccardo","Position":"Mayor","Organization":"City of San Jose, California","Alternate name":"Shireen Santosham","Alternate position":"Chief Innovation Officer, Office of the Mayor,","Photo":"Shireen Santosham.jpg","Description":"originally was the only city with a seat on the BDAC until Pai appointed Huckaba in late July.","Recommendations":"Juan Salazar, Facebook","Nominated By":"Sachin Jain, Policy Advisor","Category":"Government - elected official) B2","Working Groups":"WG3","BDAC":"TRUE"},{"Name":"Valerie Fast Horse","Position":"Founder, Rezkast.com","Organization":"Coeur d'Alene Tribe","Alternate name":"","Alternate position":"","Photo":"woman.png","Description":"is a federally recognized Native American tribe, which Fast Horse is a member; Fast Horse founded Rezkast.com, an internet provider.","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or wireless provider – startup; received 12.2M loan/grant for fiber optic project to bring broadband to tribal grounds) A1","Working Groups":"WG2","BDAC":"TRUE"},{"Name":"Allen Davis","Position":"President (likely) (1) (2) (3)","Organization":"United Telesystems, Inc. (1) (2) (3)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (public safety company – small town) A9","Working Groups":"","BDAC":""},{"Name":"Andrew M. Klein","Position":"Managing Attorney","Organization":"Klein Law Group PLLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business* (law firm) (1) A4","Working Groups":"","BDAC":""},{"Name":"Anita J. Dunning","Position":"Consultant","Organization":"Missouri Farm Bureau/American Farm Bureau Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Blake Hurst, President, Missouri Farm Bureau; Zippy Duvall, American Farm Bureau Assoc.","Category":"Business* (holding company: owns various insurance companies – works to improve quality of life for farmers) A9","Working Groups":"","BDAC":""},{"Name":"Christopher D. Coursen","Position":"President & CEO","Organization":"The Status Group","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (human resources) A9","Working Groups":"","BDAC":""},{"Name":"Colin Sandy","Position":"CEO and General Counsel","Organization":"Sandy Audio Visual LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (professional audio/visual services) A7","Working Groups":"","BDAC":""},{"Name":"David Archambault","Position":"Vice President & Founding Partner","Organization":"Virtual Site Simulations (VSS)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (information services) A7","Working Groups":"","BDAC":""},{"Name":"Don Gale","Position":"Consultant","Organization":"Technologies Management, Inc. (TMI)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Connie Wightman, CEO, TMI","Category":"Business (consulting -- firm specializing in state and federal regulatory matters) A6","Working Groups":"","BDAC":""},{"Name":"Donald Cullen","Position":"Web Developer","Organization":"Convo Communications, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jeff Rosen, General Counsel, Convo Communications","Category":"Business (video relay services for deaf and hard-of-hearing individuals**) A7","Working Groups":"","BDAC":""},{"Name":"Fred Brakeman","Position":"CEO","Organization":"Infinity Communications and Consulting , representing California Educational Technology Professionals Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Amanda Carroll, K-20 Education Network; Dwayne Camp Sr., San Mateo-Foster City School District; Jason Brem, Turlock Unified School District; Mary Phillips, West Contra Costa Unified School District","Nominated By":"Stephen Carr, President CETPA","Category":"Business (consulting - services focused on E-rate and technology design) A6","Working Groups":"","BDAC":""},{"Name":"Gary C. Pennington","Position":"Attorney","Organization":"Pennington Law Firm, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Sanford (SC); Bernadette Faiella; Willam Amman, Chase Real Estate Services; Brett Baggeln, Tarpon Towers; Carrie Larson, CTI Towers; George Davis, TowerCom; Michael Baldwin, Spirit Communications; Paul Koch; Thomas Egan, Egan Realty Services; Wendy Smith, Crown Castle; Larry Vincent; Andy Haldane, Tower Engineering Professionals; Angie Greer, Sprint; Jonathan Adelstein, WIA; William Byrd, Privacom Ventures","Nominated By":"Carrie L. Larson, General Counsel, CTI Towers, Inc.; Richard A. Jones, Attorney at Law, Dobson, Jones, Ball, Phillips & Bridges, P.A.; Daniel C. Agresta, President, Carolinas Wireless Association","Category":"Business (law firm) A4","Working Groups":"","BDAC":""},{"Name":"Gregory Whelan","Position":"Principal","Organization":"Greywale Insights","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (consulting -- consults in communications sector ** totally bogus company) A6","Working Groups":"","BDAC":""},{"Name":"James Filanc","Position":"LEED AP","Organization":"Southern Contracting Company","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"John Grau, National Electric Contractors Assoc.; Andrew Berg, NECA San Diego","Nominated By":"Lynn Murison, SCC","Category":"Business (engineering -- general engineering and electrical contracting, including for utility companies and municipalities) A5","Working Groups":"","BDAC":""},{"Name":"John M Rowe","Position":"Owner, Communications Real Estate, INC., and Telecom Bird Dogs, LLC. (applying to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (real estate agent) A9","Working Groups":"","BDAC":""},{"Name":"Jonathan Kramer","Position":"Founder/Managing Partner","Organization":"Telecom Law Firm","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Stephen Taylor, Executive Director/General Counsel, NATOA","Category":"Business (law firm - reps corporate clients regarding wireless, leasing etc.) A4","Working Groups":"","BDAC":""},{"Name":"Ken Pyle","Position":"President, Viodi LLC (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (*internet software and services, information services - highly related to telecommunications/providers, provides \"information and assistance\" to ISPs about video, creates content for them, etc.) A1","Working Groups":"","BDAC":""},{"Name":"Kevin Wagner","Position":"President & CEO","Organization":"URBan Radio Broadcasting, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (broadcasting, communications, radio) A8","Working Groups":"","BDAC":""},{"Name":"Mark Lewellen","Position":"Manager of Spectrum Advcacy","Organization":"John Deere & Company","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"John Stone, Senior Vice President of Intelligent Solutions, John Deere","Category":"Business (manufacturing - John Deere) A5","Working Groups":"","BDAC":""},{"Name":"Otis Armstrong","Position":"Executive Vice President & Chief Information Officer","Organization":"Calista Corporation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Andrew Guy, President and Chief Executive Officer, Calista Corporation","Category":"Business (construction, engineering- telecommunications listed as one of MANY services - over 10) A5","Working Groups":"","BDAC":""},{"Name":"Patricia Cooper","Position":"Vice President, Satellite Government Affairs","Organization":"Space Exploration Technologies, Corp. (SpaceX)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Tim Hughes, SVP and General Counsel, SpaceX","Category":"Business (space? launch services? lol) A9","Working Groups":"","BDAC":""},{"Name":"Paul Mitchell","Position":"Sr. Director, Technology Policy","Organization":"Microsoft","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Frederick S. Humphries, Corporate Vice President, Microsoft","Category":"Business (information, technology services) A7","Working Groups":"WG1","BDAC":""},{"Name":"Richard (Rich) Berliner","Position":"Founder, Fifth Gen Media (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (media, real estate and wireless magazine) A8","Working Groups":"","BDAC":""},{"Name":"Robert Pepper","Position":"Head, Global Connectivity Policy and Planning","Organization":"Facebook","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Chris Hemmerlein, Public Policy Manager, Facebook","Category":"Business (social media) A8","Working Groups":"WG4","BDAC":""},{"Name":"Russell S. Been","Position":"Owner","Organization":"Cellective Solutions, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (outsourcing?) A9","Working Groups":"","BDAC":""},{"Name":"Samuel J. Kline","Position":"Senior Vice President - Corporate Strategy","Organization":"Granite Telecommunications, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Sen. Wicker (MS)","Nominated By":"Rand Currier, Chief Operating Officer, Granite Telecommunications, LLC","Category":"Business (communications, communications services) A7","Working Groups":"","BDAC":""},{"Name":"Sheila Allgood","Position":"Manager of BOLT Fiber Optic Services and RECtec","Organization":"Northeast Rural Services","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Anthony Due, General Manager, Northeast Oklahoma Electric Cooperative & Northeast Rural Services, Inc. (wholly owned subsidiary of NEOEC)","Category":"Business (landscaping - \"vegetation management\") A9","Working Groups":"","BDAC":""},{"Name":"Tim Koxlien","Position":"CEO","Organization":"TeleQuality Communications, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommuniations or provider - specializes with health care clients) A9","Working Groups":"","BDAC":""},{"Name":"Tony S. Lee","Position":"Partner, Fletcher Heald & Hildreth (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (law firm) A4","Working Groups":"","BDAC":""},{"Name":"Adrian Berezowsky","Position":"Senior Managing Director, Telecom Advisory Services","Organization":"CBRE","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Mark de Stefanis, Senior Managing Director, CBRE","Category":"Business (investment) A3","Working Groups":"","BDAC":""},{"Name":"Dan Hays","Position":"Principal","Organization":"PricewaterhouseCoopers, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (accounting, auditing, assurance) A3","Working Groups":"","BDAC":""},{"Name":"David McCourt","Position":"Chairman and CEO","Organization":"Granahan McCourt Capital","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Timothy Wyllie, Partner, Granahan McCourt Capital","Category":"Business (investment - private investment firm) A3","Working Groups":"","BDAC":""},{"Name":"Maxwell Gover","Position":"Director, Media & Telecommunications Investment Banking","Organization":"Wells Fargo & Co.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (investment - banking) A3","Working Groups":"","BDAC":""},{"Name":"Ken Hill","Position":"Senior Project Manager","Organization":"PPL Infrastructure Services; PPL includes Western Power Distribution, Louisville Gas and Electric and Kentucky Utilities","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Brett Kilbourne, Utilities Telecom Council","Category":"Business (utilities, power company) A2","Working Groups":"","BDAC":""},{"Name":"Michael Luhrs","Position":"Vice President, Retail Programs","Organization":"Duke Energy, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Tom Craig, Duke Energy","Category":"Business (power company) A2","Working Groups":"","BDAC":""},{"Name":"Pam Ellis","Position":"Senior Manager, Utility Business Development","Organization":"American Electric Power","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Alexis Sulentic, EEI; Brett Kilbourne, UTC","Nominated By":"Mark Coleman, AEP","Category":"Business (power company, utilities, utility company* could not find Pam on AEP website, though confirmed on her LinkedIn A2)","Working Groups":"","BDAC":""},{"Name":"Timothy Gasser","Position":"Senior Project Manager, Wireless Collocation, Communication Sitings, & Services","Organization":"Puget Sound Energy","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Aryeh Fishman, EEI; Brett Kilbourne, UTC","Nominated By":"Wayne Gould, PSE","Category":"Business (power company) A2","Working Groups":"","BDAC":""},{"Name":"Aldo Casartelli","Position":"Vice President – High Speed Data Product (1)","Organization":"Cable ONE","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Alison Minea","Position":"Director & Senior Counsel, Regulatory Affairs","Organization":"DISH","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jeffrey Blum, Senior VP and Deputy General Counsel, DISH","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Alvaro Pilar","Position":"Chief Executive Officer","Organization":"Virgin Islands Telephone Corp. dba Innovative Telephone (owned by ATN International)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Bennett Ross, Partner, Wiley Rein","Category":"Business (telecommunications or provider) (1) A1","Working Groups":"","BDAC":""},{"Name":"Andrew B. Davis","Position":"Vice President Programming & Vendor Contracts","Organization":"Fidelity Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) (1) A1","Working Groups":"","BDAC":""},{"Name":"Andrew Cohill","Position":"President and CEO","Organization":"Wide Open Networks","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider – small town-ish; focus on affordability) (1) A1","Working Groups":"","BDAC":""},{"Name":"Andrew J. Rice","Position":"Vice President","Organization":"Ramaker & Associates","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"James Skowronski, President and CEO, Ramaker & Associates","Category":"Business (telecommunications or provider - engineering for telecom as \"core service\") A1","Working Groups":"","BDAC":""},{"Name":"Andy Heins","Position":"Senior Consultant, Strategy and Operations","Organization":"Finley Engineering","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Michael Boehne, CEO, Finley Engineering Company, Inc.","Category":"Business (telecommunications or provider – consulting engineering company) A1","Working Groups":"","BDAC":""},{"Name":"Anthony T. Lepore","Position":"Vice President & Director of regulatory affairs","Organization":"Cityscape Consultants, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Scott Stoudenmire, City of Coconut Creek FL","Nominated By":"Bernie J. Samz, President, Village of Mishicot","Category":"Business (telecommunications or provider - consulting, local govrnment on telecommunications planning and regulation) A1","Working Groups":"","BDAC":""},{"Name":"Bob Collie","Position":"Managing Director","Organization":"Parana River Group LLC (representing Education Networks of America, Inc.)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications company or provider) A1 (1)","Working Groups":"","BDAC":""},{"Name":"Robert \"Bob\" Hance","Position":"CEO","Organization":"Midwest Energy Cooperative","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Reps. Upton and Wallberg (MI); Tanya Schuitmaker, Michigan state senator; Brett Kilbourne, UTC; Eric Baker, Wolverine Power Coop.; Douglas Snitgen, MECA; Dan McClendon, Garkane; Ken Johson, Co-Mo Elec. Coop.; Michael Hastings, Shenandoah Valley Elec. Coop.; James Bagley, Raccoon Valley Elec. Coop.; Bill Scott, Great Lakes Energy; Tony Anderson, Cherryland Elec. Coop.; Matt Kappler, HomeWorks; Thomas Harrell, Alger Delta; Dallas Braun, Thumb Elec. Coop.; Deborah Miles, Ontonagon Co. Rural Electrification Assoc.","Nominated By":"David Allen, VP, Regulatory Compliance and Community Development, MEC","Category":"Business (utility provider; member-owned) (1) A2**","Working Groups":"WG3","BDAC":""},{"Name":"Bob Nichols","Position":"CEO","Organization":"Declaration Networks Group, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Daniel O'Neill, Global Information Infrastructure Commission","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Brett Lindsey","Position":"President & CEO","Organization":"Everstream Solutions, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Christian Gartner, CFO, Everstream","Category":"Business (telecommunications or provider - fiber network builder/consultant) A1","Working Groups":"","BDAC":""},{"Name":"Brian Boisvert","Position":"CEO, General Manager","Organization":"Wilson Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Sen. Roberts (KS)","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - smalltown) A1","Working Groups":"","BDAC":""},{"Name":"Brian Horn","Position":"Owner","Organization":"Winters Broadband, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - smalltown-ish; 500 square mile coverage) A1","Working Groups":"","BDAC":""},{"Name":"Brian Tagaban","Position":"Director, Government Policy","Organization":"Sacred Wind Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"John W. Badal, CEO, Sacred Wind Communications, Inc.","Category":"Business (telecommunications or provider - smalltown, Navajo service) A1","Working Groups":"WG4","BDAC":""},{"Name":"Brigitte F. Daniel","Position":"Executive Vice President","Organization":"Wilco Electronic Systems, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Adonis Hoffman, Fmr. Chief of Staff, Cmr. Clyburn","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - minority-owned, rare) A1","Working Groups":"WG4","BDAC":""},{"Name":"Bruce Chesley","Position":"Vice President and Program Manager, Global Broadband System","Organization":"The Boeing Company (Boeing Network & Space Systems)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Paul Rusnock, VP and General Manager of Satellite Systems, Boeing","Category":"Business (telecommunications or provider - relay internet connectivity and direct-to-home entertainment through satellites/spacecraft) A1","Working Groups":"","BDAC":""},{"Name":"Bruce Holdridge","Position":"General Manager","Organization":"Gila River Telecommunications, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Belinda Nelson, Chair, GRTI Board of Directors","Category":"Business (telecommunications or provider - serves the Gila River Indian Community) A1*","Working Groups":"WG1","BDAC":""},{"Name":"Chad Young","Position":"CEO & General Manager","Organization":"Norvado","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Bill Esbeck, WSTA","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Charley Karnes","Position":"Operations Manager/Network Engineer","Organization":"Wisper II","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - filed for bankruptcy 3/29/16) A1","Working Groups":"","BDAC":""},{"Name":"Charlie Cano","Position":"Chief Executive Officer","Organization":"Etex Telephone Cooperative, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Reps. Gohmert and Ratcliffe (TX); Joe Clews, EnerSys; Barry Ward, Graybar Electric Company; Jennifer Sims, PT Supply; Vern Dosch, NISC; Sandy Benton, SW Ark. Tel. Coop.; Cole Hefner, TX House of Reps.; Weldon Gray, Tex. Statewide Tel. Coop.; Steve Singletary, Taylor Tel. Coop.; Darren Patrick, WestEx; Kelly Allison, Colorado Valley Tel. Coop.; Steve Alexander, EastEx Tel. Coop.; Charles Greenberg, BTel; Wade Maner, South Plains Tel. Coop.; Clifford Humpert, CTC; Delbert Wilson, HCTC; John Brthers, PSA Inc.; Rodney Hackemack, ITC; Bill Rakowitz, YC Communications; Kirk Petty, Santa Rose Tel. Coop.; Steven Steele, Peoples","Nominated By":"Amy Linzey, Chief Executive Officer, West Texas Rural Telephone Cooperative","Category":"Business (telelcommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Chris Reno","Position":"Director of Accounting","Organization":"Union Telephone Company","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"John D. Woody, Founder and CEO, Union Telephone Co.","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Christopher J. Murphy","Position":"Associate General Counsel, Regulatory","Organization":"ViaSat, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Paul Konopka, VP, ViaSat","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Cindy D. McCarty","Position":"Senior Staff Attorney","Organization":"East Kentucky Network, LLC dba Appalachian Wireless (EKN)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"W.A. Gillum, CEO/General Manager, EKN","Category":"Business (telecommunications or provider) A1","Working Groups":"WG1","BDAC":""},{"Name":"Dale Jones","Position":"CEO","Organization":"Tri-County Telephone Association, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Angela Schwerdtfeger, Director of Public Relations, Tri-County Telephone","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Dan Whalen","Position":"President, Network and Cloud Services","Organization":"ARRIS","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Bruce McClelland, CEO, ARRIS","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Dane Jasper","Position":"CEO & Co-Founder","Organization":"Sonic.com","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Daniel Behuniak","Position":"Founder and CEO","Organization":"Skyway Towers, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - develops TOWERS for carriers) A1","Working Groups":"","BDAC":""},{"Name":"Darby McCarty","Position":"CEO","Organization":"Smithville Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Brooks (IN)","Nominated By":"Rep. Brooks (IN)","Category":"Business (telecommunications or provider - smalltown) A1","Working Groups":"","BDAC":""},{"Name":"David (\"Dave\") Mayo","Position":"SVP, Chief of Network Planning, Implementation, and Business Operations","Organization":"T-Mobile USA","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Steve Sharkey, VP, T-Mobile","Category":"Business (telecommunications or provider) A1","Working Groups":"WG3","BDAC":""},{"Name":"Dave Osborn","Position":"Chief Executive Officer","Organization":"VTX1 Companies","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Derrick Owens, WTA","Nominated By":"Self-nominated","Category":"Business (telecommunicatios or provider - smalltown, 14,000 members) A1","Working Groups":"","BDAC":""},{"Name":"David Eckard","Position":"CTO, Fixed Networks","Organization":"Nokia","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Rickey Corker, President, North America and Executive Vice President, Nokia","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"David Parker","Position":"Soler Owner/Manager","Organization":"Parket FiberNet, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Loudermilk (GA)","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - builds fiber optic network infrastructure for commercial and public applications) A1","Working Groups":"","BDAC":""},{"Name":"Dennis B. Francis","Position":"Executive Vice President & Chief Technical Officer","Organization":"Conterra Ultra Broadband Holdings, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Shane Turley, Senior VP and General Counsel, Conterra","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Derek E. White","Position":"Assistant General Manager","Organization":"San Carlos Apache Telecommunications Utility, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Derrick Owens, VP, WTA","Category":"Business (telecommunications or provider - est. by tribal resolution, tribe, smalltown) A1*","Working Groups":"","BDAC":""},{"Name":"Derek Peterson","Position":"Chief Technology Officer","Organization":"Boingo Wireless","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Gary Shapiro, CTA","Nominated By":"Dave Hagan, Chairman and CEO, Boingo Wireless","Category":"Business (telecommunications or provder - wi-fi and cellular operator) A1","Working Groups":"","BDAC":""},{"Name":"Diane Griffin Holland WG3","Position":"Vice President, Law & Policy","Organization":"USTelecom","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jonathan Spalter, President and CEO, USTelecom","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Don Nicholson","Position":"Area Manager, Viasat (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Don Patten","Position":"General Manager","Organization":"Monmouth-Independence Networks (MINET), a muni broadband network","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"John McArdle, Mayor, Independence OR","Nominated By":"Marilyn Morton, City Councilor, City of Independence, Oregon; Scott McClure, Chairman, MINET Board of Directors; Steve Milligan, Mayor, City of Monmouth, OR","Category":"Business (telecommunications or provider - smalltown, 20,000 customer base) A1","Working Groups":"","BDAC":""},{"Name":"Douglas Moore","Position":"Executive Vice President and Chief Operating Officer","Organization":"Fujitsu Network Communications, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Dustin Jurman","Position":"President","Organization":"Rapid Systems","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Denise Hamilton, VP & CFO, Rapid Systems","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Dwight \"Doc\" Wininger","Position":"Executive Vice President, External Relations","Organization":"Pinpoint Holdings, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Derrick Owens, WTA","Nominated By":"Michael B. Urdahl, President & Chief Operating Officer, Pinpoint Holdings, Inc.;","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Edward \"Ed\" G. Roach","Position":"Vice President Associate & General Counsel","Organization":"SBA Communications Corporation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Matthew Kohl, Business Intelligence Manager, SBA","Category":"Business (telecommunications or provider) A1","Working Groups":"WG4","BDAC":""},{"Name":"Elliot Noss","Position":"President & CEO, Broadband access: fiber infrastructure builder, operator and ISP","Organization":"Tucows, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunicationS or provider) A1","Working Groups":"","BDAC":""},{"Name":"Emmett James Fitch","Position":"CEO","Organization":"OptimERA WiFi","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Eric Freesmeier","Position":"President & CEO","Organization":"Pulse Broadband","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Evan Fisher","Position":"CEO & Founder","Organization":"Kinetic Technologies","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Brad Zerbe, Principal, Arizona Government Consulting","Category":"Business (telecommunications or provider - develops mixed-signal semiconductors for providers) A1","Working Groups":"","BDAC":""},{"Name":"Gabe Venturi","Position":"Chief Commercial Officer, Inmarsat (nominated to serve as an individual)","Organization":"Inmarsat Government","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Gary Bolton","Position":"Vice President of Global Marketing","Organization":"ADTRAN, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Stephen L. Goodman","Category":"Business (telecommunications or provider - provider of networking communications equipment to ISPs) A1","Working Groups":"","BDAC":""},{"Name":"Gary Griffiths","Position":"CEO","Organization":"iPass","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Asma Stewart, Public Relations and Marketing Consultant, iPass","Category":"Business (telecommunications or provider - wifi network?) A1","Working Groups":"","BDAC":""},{"Name":"Gary Jabara","Position":"Founder and CEO","Organization":"Mobilitie","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - wireless infrastructure solutions) A1","Working Groups":"","BDAC":""},{"Name":"Gene DeJordy","Position":"President and General Counsel","Organization":"Native American Telecom Enterprise, LLC (NATE)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - tribe, tribal, smalltown) A1*","Working Groups":"","BDAC":""},{"Name":"Godfrey Enjady","Position":"General Manager","Organization":"Mescalero Apache Telecom, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Danny H. Breuninger, Sr., President, Mescalero Apache Tribe","Category":"Business (telecommunications or provider - tribe, tribal, smalltown) A1*","Working Groups":"","BDAC":""},{"Name":"Gowton Achaibar","Position":"Head of Strategy & Chief Technology Officer","Organization":"Ericsson","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Kelly Shields, Director, Gov. Affairs and Public Policy, Ericsson","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Greg Bedian","Position":"Director of Engineering","Organization":"Ubiquiti Networks, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Hayley Nivelle, Chief Corporate and Commercial Counsel, Ubiquiti","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Greg Fender","Position":"President","Organization":"Local Government Services, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Reps. Carter, Ferguson and Scott (GA)","Nominated By":"Lamar Norton, Executive Director, Georgia Municipal Association","Category":"Business (telecommunications or provider - consulting, municipal and county govrnments on relationships with ISPs) A1","Working Groups":"","BDAC":""},{"Name":"Greg Palser","Position":"Vice President, Business Development","Organization":"Wave Broadband","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"H. Anthony Lehv","Position":"Senior Vice President, General Counsel and Secretary","Organization":"ExteNet Systems, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"H. Mark McGibbon","Position":"CEO & President","Organization":"Virgin Island Next Generation Network, Inc. (viNGN)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Gov. Mapp (USVI)","Nominated By":"Kenneth E. Mapp, Governor,Virgin Islands","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"James (Jim) Nevelle","Position":"President & CEO","Organization":"Kathrein USA","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Janet Britton","Position":"General Counsel","Organization":"EATEL","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"John Scanlan, CEO, EATEL","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Jason B. Williams","Position":"Chief Executive Officer","Organization":"Blackfoot","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Derrick Owens, WTA; Geoff Feiss, Montana Telecom. Assoc.","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - smalltown) A1","Working Groups":"WG3","BDAC":""},{"Name":"Jay Wilson Preston","Position":"CEO and Majority Owner","Organization":"Ronan Telephone Company","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Jeff Bertholdi","Position":"Director SpringNeT","Organization":"City Utilities of Springfield","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Scott Miller, General Manager & CEO, Utilities of Springfield, Missouri","Category":"Business (telecommunications or provider - utilities, utility - provides broadband) A1**","Working Groups":"","BDAC":""},{"Name":"Jeff Lewis","Position":"President & Founder","Organization":"VERTICOM","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Jeffry H. Smith","Position":"President & CEO","Organization":"GVNW Consulting","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - consulting on rural telecom landscape) A1","Working Groups":"","BDAC":""},{"Name":"Jerry Whisenhunt","Position":"General Manager","Organization":"Pine Telephone, Pine Cellular, Broken Bow TV Cable, and Pun-Net (ISP)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Jimmy Todd","Position":"CEO & General Manager","Organization":"Nex-Tech","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Sen. Roberts (KS); Lynn Harkin, NREDA; Scott Sproul, KEDA; Mary Jane Stankiewicz, KRITC; Michael Romano, NTCA; Kelly Worthington, WTA","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Joanne S. Hovis","Position":"President","Organization":"Columbia Telecommunications Corporation Technology & Energy","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - consulting, communications and IT engineering) A1","Working Groups":"","BDAC":""},{"Name":"John Jones","Position":"Senior Vice President, Public Policy & Regulatory Affairs","Organization":"CenturyLink","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jeff Lanning, VP, CenturyLink","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"John S. Stevens","Position":"Founder, CEO","Organization":"Infinigy","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"John Sciarabba","Position":"Founder/CEO","Organization":"Alden Systems","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - serves ISPs end-to-end software) A1","Working Groups":"","BDAC":""},{"Name":"Johnie Johnson","Position":"President & CEO","Organization":"IM Broadband, LLC dba Infiniti Broadband","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Mullin (GA)","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Jonathan Bullock","Position":"Vice President, Corporate Development & Government","Organization":"Hotwire Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Jonathan Chambers","Position":"Senior Project Manager","Organization":"Conexon","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Brett Kilbourne, Utilities Telecom Council","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Joseph Buttweiler","Position":"Partnership Development Manager","Organization":"Consolidated Telecommunications Company","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Joseph Franell","Position":"CEO","Organization":"Eastern Oregon Telecom","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Justin Gillette","Position":"Director of Risk Management","Organization":"Vertical Limit Construction","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - construction **for telecom industry largely) A1","Working Groups":"","BDAC":""},{"Name":"Ken Mason","Position":"Group Vice President, Regulatory Affairs","Organization":"Frontier Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Ken Pfister","Position":"Vice President, Strategic Planning","Organization":"Great Plains Communications, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Todd A. Foje, Chief Executive Officer, Great Plains Communications","Category":"Business (telecommunications or provider - privately owned, Nebraska-based) A1","Working Groups":"WG4","BDAC":""},{"Name":"Kenneth E. Rosenbaum, Jr.","Position":"Managing Partner, ERM (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - consulting, provides environmental/safety/risk services) A1","Working Groups":"","BDAC":""},{"Name":"Kevin Beierschmitt","Position":"President/CEO/Chair","Organization":"Flat Wireless, LLC (doing business as Cleartalk Wireless)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Kevin McGuire","Position":"Chief Operating Officer","Organization":"Enhanced Telecommunications Corp.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Messer (IN)","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Kirk Jamieson","Position":"Senior Vice President, Government Affairs","Organization":"Mobilitie","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Gary Jabara, Founder and CEO, Mobilitie","Category":"Business (telecommunications or provider) A1","Working Groups":"WG1","BDAC":""},{"Name":"Kurt Van Wagenen","Position":"President & CEO","Organization":"Firstlight","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jill Sanford, VP and General Counsel, FirstLight","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Kyle Williamson","Position":"CEO, President of the Fiber Network Owners Alliance","Organization":"DoveTel Communications LLC, dba SyncGlobal Telecom","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jim Clotfelter, Vice President, SyncGlobal Telecom","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Laurence Brett Glass","Position":"Owner, Sole Proprietor","Organization":"LARIAT","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"F","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - smalltown) A1","Working Groups":"","BDAC":""},{"Name":"Lawrence Behr","Position":"President and Chief Executive Officer","Organization":"LBA Group, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Michael W. Britner, Chief Operating Officer, LBA Group, Inc.","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Lee Seydel","Position":"Chief Technology Officer","Organization":"Fiberutilities Group, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Sen. Grassley (IA)","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider* - \"manages over 12,000 miles of fiber optic network ON BEHALF of our clients\") A1","Working Groups":"WG1","BDAC":""},{"Name":"Lon Whelchel","Position":"CEO","Organization":"AcelaNet, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - smalltown) A1","Working Groups":"","BDAC":""},{"Name":"Lyle Nyffeler","Position":"Vice President & General Manager, Sprint Customer Team","Organization":"Samsung Electronics America, Networks Division","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Mark Louison, Senior VP, Samsung","Category":"Business (telecommunications or provider) A1","Working Groups":"WG1","BDAC":""},{"Name":"Mark Gailey","Position":"President and General Manager","Organization":"Totah Communications, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Kelly Worthington, Executive Vice President, WTA-Advocates for Rural Broadband","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - smalltown) A1","Working Groups":"","BDAC":""},{"Name":"Mark J. Miller","Position":"Chief Operating Officer","Organization":"Edge Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Mark Wagner","Position":"Chief Executive Officer","Organization":"ThinkBig Networks, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Martin Yudkovitz","Position":"Board of Directors","Organization":"Cincinnati Bell","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Sens. Brown and Portman, Rep. Johnson (OH); Bob Iger, Walt Disney","Nominated By":"Christopher Wilson, Vice President and General Counsel, Cincinnati Bell","Category":"Business (telecommunications or provider) A1","Working Groups":"WG4","BDAC":""},{"Name":"Mary McDermott","Position":"Senior Vice President and General Counsel","Organization":"Lumos Networks","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Matt Larsen","Position":"CEO","Organization":"Vistabeam","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Phil Weiser","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Michael A. Hill","Position":"National Director, External Relations - Infrastructure","Organization":"ExteNet Systems, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Michael A. Way","Position":"Senior Regulatory Compliance Manager","Organization":"Caldwell Compliance","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Michael Grover","Position":"Vice President, Government Affairs","Organization":"Cox Communications, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jennifer Hightower, Senior VP and General Counsel, Cox","Category":"Business (telecommunications or provider) A1","Working Groups":"WG3","BDAC":""},{"Name":"Mike Bosch","Position":"Founder/CEO","Organization":"RG Fiber","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - serving 34,000 smalltowns) A1","Working Groups":"","BDAC":""},{"Name":"Mike Saperstein","Position":"Vice President, Federal Regulatory","Organization":"Frontier Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Ken Mason, Group VP, Frontier","Category":"Business (telecommunications or provider) A1","Working Groups":"WG1","BDAC":""},{"Name":"Mike Singh","Position":"Chairman","Organization":"Telkom Caribe Group","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider* news article) A1","Working Groups":"","BDAC":""},{"Name":"Montgomery Kosma","Position":"Executive Vice President, Global Strategic Partnerships","Organization":"Landover Wireless Corporation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Laurence Zimmerman, CEO, LWC","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Nathan Johnson","Position":"Chairman & Co-CEO","Organization":"TruConnect Communications, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"MyLoc Dinh, Asst. General Counsel and Senior Director of Gov't Affairs, TruConnect","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Neil Schlenker","Position":"Chairman of the Board of Directors","Organization":"Tri-County Telephone Association, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Don Jackson, Regulatory Mgr., TCT","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Norman D. Fekrat","Position":"Chief Strategy & revenue Officer, Lemko Corp. (applying to represent self)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Patrick J. Mastel","Position":"Associate General Counsel","Organization":"Midcontinent Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Sen. Heitkamp (SD)","Nominated By":"Scott Anderson, Chief Legal Officer, Midcontinent Communications","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Paul Belk","Position":"President & CEO","Organization":"NGN","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Collins (GA)","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - corporation of cooperatives, regional fiber optic system) A1","Working Groups":"","BDAC":""},{"Name":"Paul Eisenberg","Position":"Co-Managing Member","Organization":"Repeater Communications Group, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - customers include network broadcasting companies, cellular carriers etc.) A1","Working Groups":"","BDAC":""},{"Name":"Randy Brogle","Position":"Vice President, Dark Fiber","Organization":"Zayo Group Holdings, Inc","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Wendy Cassity, VP and General Counsel, Zayo","Category":"Business (telecommunications or provider) A1","Working Groups":"WG2","BDAC":""},{"Name":"Randy Whitehead","Position":"Director, Underlying Rights, Zayo (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Ray L. McKim, III","Position":"Independent Contractor, d/b/a Telecom Site Services (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Donald Evans, Fletcher Heald and Hildreth","Nominated By":"Self-nominated","Category":"Business (telecommunicatiosn or provider -- site services, site assessment, independent contractor) A1","Working Groups":"","BDAC":""},{"Name":"Rich Shapero","Position":"Former Managing Partner, Crosspoint Venture Partners (Retired)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - investment, in telecommunications, CLOSED*) A1","Working Groups":"","BDAC":""},{"Name":"Richard Stern","Position":"Executive Vice President & General Counsel","Organization":"Eco-Site, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Robert Glosson, President and COO, Eco-Site, Inc.","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Rick Hunt","Position":"Vice President","Organization":"TowerCom","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Chip Bulloch, Senior Vice President & Managing Partner, TowerCom","Category":"Business (developer, builds and operates towers for telecom and govrnment clients) A1","Working Groups":"","BDAC":""},{"Name":"Robert J. Shanahan","Position":"President & CEO","Organization":"Lightower Fiber Networks, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Pamela Hollis, Lightower","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Roger Schmitz","Position":"CFO","Organization":"NewCore Wireless, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Ron McCue","Position":"President & Chief Operating Officer","Organization":"Silver Star Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jonathan Spalter, President and CEO, USTelecom","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Russell A. Shipley","Position":"EVP, Wholesale, Engineering and Operations","Organization":"Tele Pacific Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Nancy Lubamerksy, VP, TelePacific","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Samuel T. Curtis","Position":"President and CEO","Organization":"AtLink Services","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Sanjay Udani","Position":"Vice President, Technology Policy","Organization":"Verizon Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Will Johnson, Senior Vice President, Federal Regulatory & Legal Affairs, Verizon Communications","Category":"Business (telecommunications or provider) A1","Working Groups":"WG2","BDAC":""},{"Name":"Saul Ramirez","Position":"President","Organization":"Global Reconnect, LLC (owner of TerraCom and YourTel)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Stanley McCright, CEO, Global Reconnect","Category":"Business (telecommunications or provider - **can't find website, just FCC document) A1","Working Groups":"","BDAC":""},{"Name":"Scott D. Rubins","Position":"President and CEO","Organization":"Geneseo Communications","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Sean Caskie","Position":"Managing Partner","Organization":"Southern Towers, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Donnie G Pell, Managing Partner","Category":"Business (telecommunications or provider - builds towers with providers) A1","Working Groups":"","BDAC":""},{"Name":"Shilah Butler","Position":"Senior Manager, Affiliate Operations","Organization":"Copper Valley Telecom","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Skyler J. Ditchfield","Position":"CEO","Organization":"California Internet LP (now GeoLinks)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Fmr. FCC Commissioner Rochelle Chong","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Sonja Wall","Position":"Director","Organization":"OneNet","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Vonley Royal, Executive Director of OneNet & the Chief Information Officer for the Oklahoma state Regents for Higher Education","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Stacey Aughe","Position":"Chief Administrative Officer","Organization":"Union Telephone Company","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"John D. Woody, Founder and CEO, Union Telephone Co.","Category":"Business (telecommunications or provider - smalltown, *couldn't find CEO on website) A1","Working Groups":"","BDAC":""},{"Name":"Stacey Brigham","Position":"Senior Regulatory Consultant","Organization":"TCA","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Chris Schroeder, CEO, TCA","Category":"Business (telecommunications or provider - consulting, for wireless solutions) A1","Working Groups":"","BDAC":""},{"Name":"Stacy Hurd","Position":"Manager, Cox Communications (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider *can't find Stacy on website) A1","Working Groups":"","BDAC":""},{"Name":"Stephen J. Szymanski","Position":"Vice President, Prysmian Group (nominated to represent self)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Stephen Morris","Position":"Principal/Owner","Organization":"Foothillsnet, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider -*can't find website but it's a member of WISPA, which reps ISPs) A1","Working Groups":"","BDAC":""},{"Name":"Stephen T. Yelverton","Position":"Managing-Member","Organization":"Carolina-Potomac Land Holdings, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - *can't find website but FCC lists it as a broadband service) A1","Working Groups":"","BDAC":""},{"Name":"Steve Papa","Position":"Founder, Chairman & CEO","Organization":"Parallel Wireless","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Steve Vondran","Position":"Senior Vice President, US Operations","Organization":"American Tower Corporation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Jonathan Adelstein, WIA","Nominated By":"Steven C. Marshall, Executive Vice President, and President of the US Tower Division, American Tower Corporation","Category":"Business (telecommunications or provider - builds towers, hosts cellular and wireless communications equipment) A1","Working Groups":"WG3","BDAC":""},{"Name":"Steven L Barnes","Position":"Wireless Operating Manager","Organization":"New Lisbon Broadband and Communications (NLBC)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Derrick Owens, WTA","Nominated By":"John E. Greene, CEO & General Manager, NLTC, INC. & NLBC, Inc.","Category":"Business (telecommunications or provider - *can't find Steven on website) A1","Working Groups":"","BDAC":""},{"Name":"Susan Corbett","Position":"CEO/Owner","Organization":"Axiom","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Mark Oulette, President, Axiom","Category":"Business (telecommunicatiosn or provider) A1","Working Groups":"","BDAC":""},{"Name":"Terry Birk","Position":"Director of Operations","Organization":"Nsight","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Lee Thibaudeau, Chief Technical Officer and Vice President of Engineering, Nsight","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Thomas A. Reiman","Position":"President","Organization":"The Broadband Group","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Pete Ernaut, President & Principal, Government & Public Affairs, R&R Partners; Nick Vassiliadis, Government & Public Affairs Political Director, R&R Partners","Category":"Business (telecommunications or provider - consulting, ISPs and public utilities etc.) A1","Working Groups":"","BDAC":""},{"Name":"Thomas P. Farrell","Position":"CEO","Organization":"Rural Tennessee Wireless Internet Provider, Wisper II, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Tina Pidgeon","Position":"Strategic Leader, Legal and Policy Initiatives","Organization":"GCI","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Lindsay Solie, Manager, Federal Affairs, GCI","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Christianna Barnhart","Position":"Executive Vice President, Field Operations","Organization":"Charter Communications, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Christianna Lewis Barnhart, VP, Charter","Category":"Business (telecommunications or provider) A1","Working Groups":"WG2","BDAC":""},{"Name":"Tony Whaley","Position":"Sr. Project Manager, Mobility Infrastructure, KCI Technologies (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider - consulting, engineering) A1","Working Groups":"","BDAC":""},{"Name":"Virginia Lam Abrams","Position":"Senior Vice President of Communications & Government Relations","Organization":"Starry","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Chaitanya (Chet) Kanojia, CEO & Co-Founder, Starry","Category":"Business (telecommunications or provider) A1","Working Groups":"WG2","BDAC":""},{"Name":"William Bradford","Position":"","Organization":"United Communications; Tennessee Telecommunications Association; IRIS Networks (need to clarify which entity he will represent - it is not clear from his application)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Zachary Cutrell","Position":"Operations Manager","Organization":"Citizens Fiber","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Business (telecommunications or provider) A1","Working Groups":"","BDAC":""},{"Name":"Danae Wilson","Position":"Manager, Department of Technology Services","Organization":"Nez Perce Tribe","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Mary Jane Mlles, Chairman, Nez Perce Tribe","Category":"Government - tribe, tribal government - department of technology services, Nez Perce Tribe) B4","Working Groups":"","BDAC":""},{"Name":"David Greendeer","Position":"Legislator","Organization":"Ho-Chunk Nation of Wisconsin","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - tribe, tribal government - elected member of tribal legislature) B4","Working Groups":"","BDAC":""},{"Name":"Donald Long Knife","Position":"Information Technology Specialist","Organization":"Fort Belknap Indian Community","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"George Horse Capture, Vice President, Fort Belknap Indian Community Council","Category":"Government (tribe, tribal) B4","Working Groups":"","BDAC":""},{"Name":"Shane Valdez","Position":"Council Member","Organization":"Jicarilla Apache Nation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Wainwright Velarde, President, Jicarilla Apache Nation","Category":"Government (tribe, tribal - cannot find website) B4","Working Groups":"","BDAC":""},{"Name":"Adelina Garcia Zendejas","Position":"Deputy Director, Broadband and Digital Literacy & Tribal Liaison","Organization":"California Department of Technology","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government (department of technology) B3","Working Groups":"","BDAC":""},{"Name":"Angie Dickison","Position":"Wisconsin State Board Director","Organization":"Public Service Commission of Wisconsin","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Charlene Smith, Office of the Commission, Wisconsin Public Service; and Ellen Nowak, Chairperson, Wisconsin Public Service Commission","Category":"Government (utility regulation) (1) B3","Working Groups":"","BDAC":""},{"Name":"Brian Podmenik","Position":"Real Property Agent","Organization":"City of Henderson, NV","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Robert A. Murnane, City Manager, Henderson, NV","Category":"Government (don't have a clear hold on his job description - all I can find is an article citing him as the city's property agent) B3","Working Groups":"","BDAC":""},{"Name":"Bruce Patterson","Position":"Technology Director","Organization":"City of Ammon, ID","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Dana Kirkham, Mayor, City of Ammon","Category":"Government - technology services department B3)","Working Groups":"","BDAC":""},{"Name":"Charlie Jackson","Position":"SECA Member (also E-rate Analyst Senior, State E-rate coordinator for State of Georgia)","Organization":"SECA (State E- Rate Coordinator's Alliance)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government? education - state dep. of education) B3","Working Groups":"","BDAC":""},{"Name":"Chong Liu","Position":"Advisor, Regulatory Infrastructure","Organization":"City of Boston Law Department","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - city law department) B3","Working Groups":"","BDAC":""},{"Name":"Chris McMasters","Position":"Chief Information Officer","Organization":"City of Corona, California","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Clarence Anthony, CEO and Executive Director, National League of Cities; Steve Traylor, Executive Director, National Assoc. of Telecommunciations Officers and Advisors","Category":"Government - city information technology director, information technology department) B3","Working Groups":"","BDAC":""},{"Name":"Chris Moore","Position":"Executive Director","Organization":"Kentucky Communications Network Authority","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - office of the governor, part of the general government cabinet); created to oversee KentuckyWired network (open-access broadband network ** left in March, nobody knows where he is..lol)( B3","Working Groups":"","BDAC":""},{"Name":"Clark D. Riemer","Position":"Policy Advisor to the North Carolina House of Representatives Appropriations Committee on Information Technology & the North Carolina General Assembly Joint Legislative Oversight Committee on Information Technology","Organization":"The North Carolina General Assembly","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - policy advisor/research assistant to senior house finance chairman) B3","Working Groups":"","BDAC":""},{"Name":"Conal McNamara","Position":"Director, Community Development","Organization":"City of Whittier, California","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Clarence Anthony, CEO and Executive Director, National League of Cities; Steve Traylor, Executive Director, National Assoc. of Telecommunciations Officers and Advisors","Category":"Government - Community development department, city of Whittier) B3","Working Groups":"","BDAC":""},{"Name":"Craig P. Orgeron","Position":"Executive Director","Organization":"Mississippi Department of Information Technology","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - department of information technology services) B3","Working Groups":"","BDAC":""},{"Name":"Danna MacKenzie","Position":"Executive Director","Organization":"MN Office of Broadband Development","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - office of broadband development, supports governor's broadband subcabinet) B3","Working Groups":"WG2","BDAC":""},{"Name":"David Frasher","Position":"City Manager","Organization":"City of Hot Springs, Arkansas","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government appointment to city manager?) B3","Working Groups":"","BDAC":""},{"Name":"Deborah Lathen","Position":"Former Bureau Chief, FCC Cable Services Bureau","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Fmr. FCC Chairman Kennard","Nominated By":"Fmr. FCC Chairman Kennard","Category":"Government - FORMER cable services bureau of FCC) B3","Working Groups":"","BDAC":""},{"Name":"Derrel Fincher","Position":"Coordinator, State E-Rate Program","Organization":"State E-rate Coordinators Alliance","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Gary Rawson, Federal Programs Coordinator, MS Dep't of IT Services","Category":"Government? education - state dep. of education) B3","Working Groups":"","BDAC":""},{"Name":"Gary Carter","Position":"Community Broadband Manager","Organization":"City of Santa Monica","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Ted Winterer, Mayor, City of Santa Monica","Category":"Government - Santa Monica City Net (fiber network) established by city of Santa Monica) B3","Working Groups":"","BDAC":""},{"Name":"Gary Rawson","Position":"Coordinator, Federal Programs - E-rate, Mississippi Department of Information Technology Services","Organization":"SECA (State E- Rate Coordinator's Alliance)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government? education - state dep. of education) B3","Working Groups":"","BDAC":""},{"Name":"Gary Vondrasek","Position":"Manager, Telecom Sales & Services","Organization":"JEA","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government; utilities; government agency - community owned electric, water and sewer utility) B3","Working Groups":"","BDAC":""},{"Name":"Jeffrey R. Sural","Position":"Director, Broadband Infrastructure Office","Organization":"North Carolina Department of Information Technology","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Gov. Cooper (NC)","Nominated By":"Danny Lineberry, Acting Secretary, NCDIT","Category":"Government - department of information technology) B3","Working Groups":"","BDAC":""},{"Name":"Jeffrey S. Nordhaus","Position":"Executive Vice President, Innovation & Broadband","Organization":"Empire State Development Corporation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"John Beahn, Partner, Skadden Arps","Category":"Government - created by department of economic development) B3","Working Groups":"","BDAC":""},{"Name":"Joe Webster; or Jack Belcher","Position":"Chief Information Officer or Program Manager","Organization":"Department of Technology Services or ConnectArlington","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jack Belcher, CIO, Arlington County","Category":"Government - department of technology services) B3","Working Groups":"","BDAC":""},{"Name":"Kathy Johnson","Position":"Director","Organization":"Alabama Office of Broadband Development","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Gov. Bentley (AL)","Nominated By":"Franklin Johnson, Deputy Chief of Staff, Office of the Governor","Category":"Government, state program - office created by governor - **program does not exist, failed or othrwise, Johnson no longer works for the non-existent office but as an independent consultant) B3","Working Groups":"WG4","BDAC":""},{"Name":"Kevin Pagan","Position":"City Attorney","Organization":"City of McAllen, Texas","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Clarence Anthony, CEO and Executive Director, National League of Cities; Steve Traylor, Executive Director, National Assoc. of Telecommunciations Officers and Advisors","Category":"Government - city attorney) B3","Working Groups":"WG2","BDAC":""},{"Name":"Larry Gates","Position":"Director of Utilities","Organization":"City of Chanute, Kansas","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - dep. of utilities) B3","Working Groups":"","BDAC":""},{"Name":"Larry Hanson","Position":"City Manager","Organization":"City of Valdosta, GA","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Reps. Carter, Ferguson and Scott (GA)","Nominated By":"John Gayle, Mayor, City of Valdosta, GA and member of the Georgia Municipal Association (GMA)","Category":"Government - appointed, city manager) B3","Working Groups":"WG3","BDAC":""},{"Name":"Luke Holtschneider","Position":"Manager of Rural Development","Organization":"Missouri Department of Economic Development","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - department of economic development) B3","Working Groups":"","BDAC":""},{"Name":"Miguel Gamino","Position":"Chief Technology Officer","Organization":"City of New York","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Sam Cooper, Senior Advisor, NYC Mayor's office","Category":"Government - department of information technology and telecommunications) B3","Working Groups":"WG3","BDAC":""},{"Name":"Omar Masry","Position":"Senior Analyst, city planner","Organization":"`","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Clarence Anthony, CEO and Executive Director, National League of Cities; Steve Traylor, Executive Director, National Assoc. of Telecommunciations Officers and Advisors","Category":"Government, department of planning - city planner)* news article source B3","Working Groups":"","BDAC":""},{"Name":"Peter I. Collins","Position":"Information Technologies Manager","Organization":"City of Geneva, Illinois","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - information systems, *news article source) B3","Working Groups":"","BDAC":""},{"Name":"Roger Buell","Position":"Asst. City Engineer","Organization":"City of Miami Beach, FL","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - city engineer) B3","Working Groups":"","BDAC":""},{"Name":"Sandeep Taxali","Position":"Senior Policy Analyst, Broadband Development Officer","Organization":"NTIA, Department of Commerce","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Ray Cagle, Clearwave Communications; Essam El-Beik, Department of Innovation & Technology, Illinois Century Network","Category":"Government - department of commerce, executive agency) B3","Working Groups":"","BDAC":""},{"Name":"Sandy Jones","Position":"Commissioner and Chairman","Organization":"Public Regulation Commission, State of New Mexico","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Lujan (NM); Melena Barzalai, Windstream; Charles Ferrell, NM Exchange Carrier Group","Nominated By":"Commissioners, PRC","Category":"Government - state regulation commission, district 5) B3","Working Groups":"","BDAC":""},{"Name":"Scott Majewski","Position":"Principal Planner","Organization":"City of Henderson, NV","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Robert A. Murnane, City Manager, Henderson, NV","Category":"Government, city planner, planning) B3","Working Groups":"","BDAC":""},{"Name":"Scott Shapiro","Position":"Chief Innovation Officer","Organization":"City of Lexington, Kentucky","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jim Gray, Mayor, Lexington, Kentucky","Category":"Government, Chief Innovation Officer, city administration) B3","Working Groups":"","BDAC":""},{"Name":"Steve Hargis","Position":"Division Manager, Technology Services","Organization":"City of Moreno Valley, California","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - technology services division, city manager's office) B3","Working Groups":"","BDAC":""},{"Name":"Steve Horner","Position":"Senior Assistant Attorney","Organization":"City of Overland Park, Kansas","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Tammy Owens, City Attorney, Overland Park KS","Category":"Government - senior assistant city attorney) B3","Working Groups":"","BDAC":""},{"Name":"Todd Lawrence","Position":"Coordinator, State E-Rate Program, Idaho State Department of Education","Organization":"SECA (State E- Rate Coordinator's Alliance)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Gary Rawson, Federal Programs Coordinator, MS Dep't of IT Services","Category":"Government - Idaho, department of education) B3","Working Groups":"","BDAC":""},{"Name":"Charlie P. McMahon","Position":"Vice President, Information Technology & Chief Technology Officer","Organization":"Tulane University","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Randall Legeai, Director, Institutional Program Development, Tulane","Category":"Government -- higher education) B1","Working Groups":"","BDAC":""},{"Name":"Geoff Belleau","Position":"Education Program Consultant","Organization":"California Department of Education","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jerry Winkler, Director, Educational Data Management Div., CDoE","Category":"Government - department of education, education technology) B1","Working Groups":"","BDAC":""},{"Name":"Julia Benincosa Legg","Position":"Coordinator, State E-Rate Program","Organization":"West Virginia Department of Education","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government, education - west virginia department of education) B1","Working Groups":"","BDAC":""},{"Name":"Karl Horvath","Position":"Chief Information Officer","Organization":"La Salle University","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government, education - technology dep, public university ) B1","Working Groups":"","BDAC":""},{"Name":"Karl Kowalski","Position":"Chief Information Technology Officer","Organization":"University of Alaska System","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government, education - technology, public university) B1","Working Groups":"","BDAC":""},{"Name":"Marc Hoit","Position":"Vice Chancellor, Information Technology & CEO","Organization":"North Carolina State University","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Matthew Hall, Internet2","Nominated By":"Randy Woodson, Chancellor, NC State Univ.","Category":"Government, education - office of information technology, public university) B1","Working Groups":"","BDAC":""},{"Name":"Mark Las","Position":"Director of IT Operations and Security","Organization":"Columbia College Chicago","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Byron S. Nash, Chief Information Officer and Associate Vice President for Technology Services, Columbia College Chicago","Category":"Government, education - department of information technology, public university) B1","Working Groups":"","BDAC":""},{"Name":"Patrick Cutler","Position":"Distance Learning Facilitator","Organization":"Bering Strait School District (BSSD)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government, public education - tribe, tribal involvement by nature of demographics in district) B1","Working Groups":"","BDAC":""},{"Name":"Ray Timothy","Position":"CEO & Executive Director","Organization":"Utah Education and Telehealth Network","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Kelleigh Cole, Director, Utah Broadband Outreach Center","Category":"Government program, statewide education network) B1","Working Groups":"","BDAC":""},{"Name":"Sheryl Abshire","Position":"Chief Technology Officer","Organization":"Calcasieu Parish Public Schools (Louisiana)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"The Consortium for School Networking & International Society for Technology Education","Category":"Government - public school, education) B1","Working Groups":"","BDAC":""},{"Name":"Vince Scheivert","Position":"Chief Information Officer","Organization":"Albemarle County Public Schools/ VA Society for Tech.in Education","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Pamela Moran, Albemarle County Public School (ACPS), Superintendent; Karen Richards, Executive Director, Virginia Society for Technology in Education (VSTE)","Category":"Government, education - department of accountability, research & technology) B1","Working Groups":"","BDAC":""},{"Name":"Bill Clarkson","Position":"Mayor","Organization":"City of San Ramon, California","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Swalwell (CA)","Nominated By":"Patricia Jordan, Jordan & Associates","Category":"Government (elected official) B2","Working Groups":"","BDAC":""},{"Name":"Daniel P. Friesen","Position":"Mayor","Organization":"Town of Buhler, KS","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Sen. Roberts (KS); Rich Felts, KS Farm Bureau","Nominated By":"Self-nominated","Category":"Government - elected official) B2","Working Groups":"WG1","BDAC":""},{"Name":"David Guttenberg","Position":"Representative","Organization":"Alaska State Legislature","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - elected official, district 4 state legislature) B2","Working Groups":"","BDAC":""},{"Name":"Deb Peters","Position":"State Senator, South Dakota","Organization":"State of South Dakota","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Commissioners, South Dakota PUC; SDTA","Nominated By":"Mark Shlanta, CEO, SDN Communications","Category":"Government - elected official, state senate) B2","Working Groups":"","BDAC":""},{"Name":"Hans Reimer","Position":"Councilmember at Large","Organization":"Montgomery County Maryland","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - elected to Montgomery county council) B2","Working Groups":"","BDAC":""},{"Name":"Keith Brady","Position":"Mayor","Organization":"City of Newnan, Georgia & Georgia Municipal Association (GMA)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Reps. Carter, Ferguson and Scott (GA)","Nominated By":"Lamar Norton, Executive Director, Georgia Municipal Association,","Category":"Government - elected official, mayor) B2","Working Groups":"","BDAC":""},{"Name":"Tom Sloan","Position":"Kansas State Representative","Organization":"Kansas State Government","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - elected official, state legislature) B2","Working Groups":"WG4","BDAC":""},{"Name":"Mark Keam","Position":"Member","Organization":"Virginia House of Delegates","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Government - elected official) B2","Working Groups":"","BDAC":""},{"Name":"Delaine Eastin","Position":"","Organization":"Napa County Office of Education","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Barbara Nemko, Superintendent, Napa County Schools","Category":"Government, education - elected official (former), superintendent) B2","Working Groups":"","BDAC":""},{"Name":"Barry D. Umansky","Position":"Professor/Attorney, Department of Telecommunications; DPI Director, Secretary and Senior Fellow; formerly represented broadcasters (1)","Organization":"Digital Policy Institute (DPI)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (academia – institute, research center) (2)","Working Groups":"","BDAC":""},{"Name":"Berin Szoka","Position":"President","Organization":"TechFreedom","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (think tank, nonprofit – technology policy) (1)","Working Groups":"WG2","BDAC":""},{"Name":"Betsy Feigin","Position":"General Counsel & Policy Expert on Telecommunications issues","Organization":"National Multi-Family Housing Council","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (nonprofit – reps/aids multi-family real estate interests) E3 (1)","Working Groups":"","BDAC":""},{"Name":"Brian Behlendorf","Position":"Executive Director","Organization":"Hyperledger (project of Linux Foundation)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (open source collaboration iniative; building blockchain technologies)","Working Groups":"","BDAC":""},{"Name":"Brian Wahler","Position":"Mayor, Piscataway, NJ","Organization":"US Conference of Mayors","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Kevin McCarty, Asst. Executive Director, US Conference of Mayors","Category":"Other (conference - municipal, nonpartisan)","Working Groups":"","BDAC":""},{"Name":"Chelsea Collier","Position":"Founder","Organization":"Digi City","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Roslyn Layton","Nominated By":"Self-nominated","Category":"Other (blog)","Working Groups":"","BDAC":""},{"Name":"David Burstein","Position":"Editor, Broadband reporting","Organization":"Fastnet.news","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (blog)","Working Groups":"","BDAC":""},{"Name":"David Kunstler","Position":"Principal","Organization":"Claremont Capital & Research","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (Business - investment or consulting, wealth management - NO website, dude has like 2 connections on LinkedIn)","Working Groups":"","BDAC":""},{"Name":"David Witkowski","Position":"Consultant - Wireless Communications and Civic Technology initiatives","Organization":"Joint Venture Silicon Valley","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Roslyn Layton","Nominated By":"Russell Hancock, President & CEO, Joint Venture Silicon Valley;","Category":"Other (nonprofit - \"public-private civic entrepreneurship organization,\" addresses regional issues, almost like a thnk tank?) E3","Working Groups":"","BDAC":""},{"Name":"Deirdre C. Flynn","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (no info?) E4","Working Groups":"","BDAC":""},{"Name":"Doug Brake","Position":"Senior Analyst, Telecom Policy","Organization":"Information Technology and Innovation Foundation (ITIF)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Robert D. Atkinson, President and Founder, ITIF","Category":"Other (nonprofit, think tank -- policy solutions for technology innovation, etc.)","Working Groups":"WG4","BDAC":""},{"Name":"Ellen Wolfhagen","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Eric Chambers","Position":"Director, E-Rate","Organization":"Northwest Council for Computer Education","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Heidi Rogers,CEO, NCCE","Category":"Other (nonprofit - provides professional development to educators for the effective uses of technology) E3","Working Groups":"","BDAC":""},{"Name":"Garland McCoy","Position":"Founder, President","Organization":"Technology Education Institute","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Jeffery Eisenach","Nominated By":"Self-nominated","Category":"Other (think tank, nonprofit - economics of innovation, technological change, and related regulation)","Working Groups":"","BDAC":""},{"Name":"George Ford","Position":"Chief Economist","Organization":"Phoenix Center for Advanced Legal & Economic Public Policy Studies","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Lawrence J. Spiwak, President","Category":"Other (think tank, nonprofit - economic and material implications of regulatory and economic policy)","Working Groups":"WG2","BDAC":""},{"Name":"James Noble Bradley","Position":"Attorney","Organization":"Law Office of James Bradley","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (Business - law firm** can't find)","Working Groups":"","BDAC":""},{"Name":"Jason Adkins (NOTE: Application Withdrawn)","Position":"President","Organization":"Unite Private Networks","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Graves (MO)","Nominated By":"Matt Wiltanger, General Counsel, UPN","Category":"Other","Working Groups":"","BDAC":""},{"Name":"Jeff Gavlinski","Position":"Co-Chair","Organization":"Mountain Connect","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Doug Adams, Think Agency","Category":"Other (conference)","Working Groups":"","BDAC":""},{"Name":"Jim Bowles","Position":"Former Project Engineer (Retired)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (Business - engineer** self-reported)","Working Groups":"","BDAC":""},{"Name":"Jocelyn Tate","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Jogchum Poodt","Position":"Manager","Organization":"US Department of Housing and Urban Development","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Ronald Ashford, Director, HUD Public Housing Support Services","Category":"Other (Govrnment** can't see that he actually works for the department)","Working Groups":"","BDAC":""},{"Name":"John Campbell","Position":"Vice President and General Counsel","Organization":"MetroNet Holdings, LLC.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Albert E. Cinelli, Chairman, Metronet Holdings, LLC","Category":"Other (Business **no website)","Working Groups":"","BDAC":""},{"Name":"John W. (Jack) Thompson Jr.","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Maria Mayorga","Position":"Chief Visionary Officer","Organization":"eStrategy.tech","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (digital communications technology lab* not sure this is a real thing)","Working Groups":"","BDAC":""},{"Name":"Mark A. Stachiw, Esq.","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Mason Bradshaw \"Brad\" Zerbe","Position":"Principal/Owner","Organization":"Arizona Government Consulting, LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (Business - consulting** but no website for \"Arizona Govrnment Consulting)","Working Groups":"","BDAC":""},{"Name":"Matthew Lee","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Michael J. McHale (Mac)","Position":"CEO","Organization":"Expansion Services LLC","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Dustin Laun","Nominated By":"Brad Zerbe, Principal, Arizona Government Consulting","Category":"Other (Business - telecommunications or provider ** no website)","Working Groups":"","BDAC":""},{"Name":"Michael Meyers","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Michael Robert Walters","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Janice Walters","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Michael Santorelli","Position":"Director, Advanced Communications Law and Policy Institute, New York Law School (nominated to serve as individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Charles Davidson, Director, ACLP","Category":"Other (academia - institute housed in New York Law School)","Working Groups":"WG2","BDAC":""},{"Name":"Mike Day","Position":"Exec. Officer and Founder, TribalNet (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (tribe, tribal *confusing website)","Working Groups":"","BDAC":""},{"Name":"Nicol E. Turner-Lee","Position":"Fellow, Center for Technology Innovation, Governance Studies","Organization":"Brookings Institution","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (think tank)","Working Groups":"WG1","BDAC":""},{"Name":"Peter Welch (NOTE: Application withdrawn)","Position":"Member of Congress (VT)","Organization":"U.S. House of Representatives (VT)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Clarence Anthony, CEO and Executive Director, National League of Cities; Steve Traylor, Executive Director, National Assoc. of Telecommunciations Officers and Advisors","Category":"Other","Working Groups":"","BDAC":""},{"Name":"Phillip J. Spevak","Position":"Founder","Organization":"Baltimore Broadband Coalition","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (unofficial coalition for better broadband - not approved by city council)","Working Groups":"","BDAC":""},{"Name":"Richard Bennett","Position":"Founder/Publisher, HighTechForum.org (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (forum)","Working Groups":"WG3","BDAC":""},{"Name":"Richard Ruben","Position":"Founder and Chairman, Sandy Feet Advisors LLC (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (Business **no website, LinkedIn description is unclear)","Working Groups":"","BDAC":""},{"Name":"Rob Carlisle","Position":"Founding member & Facilitator","Organization":"Dublin Broadband Consortium","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Dennis Acosta, Founding member, Dublin Broadband Consortium","Category":"Other (unofficial group, coalition - working to assess satisfaction with ISPs)","Working Groups":"","BDAC":""},{"Name":"Robert Kingett","Position":"Freelance adaptive technology instructor; writer","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (freelance)","Working Groups":"","BDAC":""},{"Name":"Robin Mersh","Position":"CEO","Organization":"Broadband Forum","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (nonprofit industry organization - focused on faster broadband networks*)","Working Groups":"","BDAC":""},{"Name":"Ron Reyer","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Ronald C. Johnson","Position":"Individual","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other E4","Working Groups":"","BDAC":""},{"Name":"Rouzbeh Yassini","Position":"Executive Director","Organization":"Univ. of New Hampshire Broadband Center of Excellence","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (academia - center housed in University of New Hampshire)","Working Groups":"","BDAC":""},{"Name":"Sam Zappas","Position":"Municipal Broadband Expert/Tech Entrepreneur (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (freelance?)","Working Groups":"","BDAC":""},{"Name":"Silvia Elaluf-Calderwood","Position":"Visiting Research Scholar; Associated Research Fellow","Organization":"Florida International University; Oxford Brookes University (respectively)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Roslyn Layton","Nominated By":"Self-nominated","Category":"Other (academia)","Working Groups":"","BDAC":""},{"Name":"Stephan Jones","Position":"Professor, Department Head, and DPI Director, Treasurer and Senior Fellow","Organization":"Digital Policy Institute (DPI)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Barry D. Umansky, Director, Secretary, and Senior Fellow, Digital Policy Institute","Category":"Other (academia - institute housed in Ball State University)","Working Groups":"","BDAC":""},{"Name":"Stuart N. Brotman","Position":"Professor, University of Tennessee, Knoxville (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (academia - professor of journalism and electronic media)","Working Groups":"","BDAC":""},{"Name":"Sunne McPeak","Position":"President & Coe, California Emerging Technology Fund","Organization":"CUE","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Mike Lawrence, CEO, CUE","Category":"Other (nonprofit est. in mergers with ISPs and California Public Utilities Commission, accelerates deployment of broadband) E3","Working Groups":"","BDAC":""},{"Name":"Thomas E. Coleman","Position":"Founder/Chief Executive Officer","Organization":"Brilliant Nations Corporation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (Business, no real information available, it exists/is active)","Working Groups":"","BDAC":""},{"Name":"Tom Giovanetti","Position":"President","Organization":"Institute for Policy Innovation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (think tank - nonprofit, public policy focus)","Working Groups":"","BDAC":""},{"Name":"Vijay Venkateswaran","Position":"CEO, Viventum Inc. (nominated to serve as an individual)","Organization":"","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (Business, investment or consulting -- consulting; no website, just Vijay's LinkedIn)","Working Groups":"","BDAC":""},{"Name":"William Rinehart","Position":"Director, Technology and Innovation Policy (nominated to serve as an individual)","Organization":"American Action Forum","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Other (nonprofit - reps right/center policy solutions, seems like a thnk tank) E3","Working Groups":"","BDAC":""},{"Name":"Aaron Deacon","Position":"Founder/Managing Director","Organization":"KC Digital Drive","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (nonprofit - civic tech startup, expanding access) C2","Working Groups":"WG1","BDAC":""},{"Name":"Adrianne B. Furniss","Position":"Executive Director","Organization":"Benton Foundation (Benton)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Kip Roderick, Secretary of the Board of Directors, Benton","Category":"Advocacy (private foundation, concerned with expanding access) C2","Working Groups":"","BDAC":""},{"Name":"Carmen Scurato","Position":"Director, Policy & Legal Affairs","Organization":"National Hispanic Media Coalition","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Alex Nogales, President, National Hispanic Media Coalition","Category":"Advocacy (nonprofit - for advacement of Latinos in media) C1","Working Groups":"","BDAC":""},{"Name":"Charles Dorsey","Position":"Executive Director","Organization":"COR Community Development Corporation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (nonprofit - for people of color, \"by forming partnerships with public and private sectors\") C1","Working Groups":"","BDAC":""},{"Name":"Chike Aguh","Position":"Chief Executive Officer","Organization":"Everyone On","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Sarah Graham, Communications & Marketing Manager, Everyone On","Category":"Advocacy (nonprofit - concerned with digital divide, expanding access) C2","Working Groups":"","BDAC":""},{"Name":"Cortney Buffington","Position":"Executive Director","Organization":"Kansas Research and Education Network (KanREN)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"James L. Stewart, Chief Technology Officer, Utah Education and Telehealth Network; Cory Faldine, CIO of Emporia State University & Chair of the Board of Directors for kanREN, Inc.; Melinda Stanley, Former State Ed Tech Director/KS E-rate, Coordinator Kansas Department of Ed, currently with KanREN","Category":"Advocacy (nonprofit - different, literally serves as a broadband provider but members only pay exactly how much it costs to deliver services, expanding access) C2","Working Groups":"","BDAC":""},{"Name":"Donald Cravins","Position":"SVP, Policy/Executive Director, Washington Bureau","Organization":"National Urban League","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Hazeen Ashby, Director, Tech. and Telecom Policy, NUL","Category":"Advocacy (civil rights organization) C1","Working Groups":"","BDAC":""},{"Name":"Grant Seiffert","Position":"Board of Directors","Organization":"Connected Nation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (nonprofit - cares about closing the digital divide, facilitates private-public partnerships, expanding access) C2","Working Groups":"WG1","BDAC":""},{"Name":"Hunter Goosman","Position":"Executive Director & CEO","Organization":"The Education and Research Consortium of the Western Carolinas, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (nonprofit - promotes better use of technology in education, expanding access; ** insufficient sources) C2","Working Groups":"","BDAC":""},{"Name":"Ken Stewart","Position":"President","Organization":"Metropolitan Council of Low Vision Individuals, a Chapter of CCLVI","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (membership organization - advocates on behalf of people with low vision) C1","Working Groups":"","BDAC":""},{"Name":"Mark Buell","Position":"Regional Bureau Director for North America","Organization":"Internet Society","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Sally Wentworth, Vice President of Global Policy Development, Internet Society","Category":"Advocacy (nonprofit - advocates for open internet, concerned with expanding access) C2","Working Groups":"","BDAC":""},{"Name":"Michael Potter","Position":"Founder","Organization":"Geeks Without Frontiers","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Christopher Scott, Member of the Board of Directors, Geeks Without Frontiers","Category":"Advocacy (\"nonprofit - concerned with expanding access, broadband for the next billion\") C2","Working Groups":"WG4","BDAC":""},{"Name":"Nick Maynard, PhD","Position":"Chief Strategy Officer","Organization":"US Ignite, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"William Wallace, Executive Director, US Ignite","Category":"Advocacy (nonprofit startup.. nonprofit; accelerates wired and wireless networking) C2","Working Groups":"","BDAC":""},{"Name":"Paul Goodman","Position":"Senior Legal Counsel, Telecommunications","Organization":"The Greenlining Institute","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (institute, nonprofit - policy, research centering on economic justice) C1","Working Groups":"","BDAC":""},{"Name":"Roberto Gallardo","Position":"Associate Extension Professor, Mississippi State University Extension;","Organization":"National Digital Inclusion Alliance","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (nonprofit, digital inclusion, expanding access) C2","Working Groups":"","BDAC":""},{"Name":"Ron Walters","Position":"Executive Director","Organization":"Pangaea Internet","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"James B. Edwards, President, e-Polk, Inc. dba Pangea Internet","Category":"Advocacy (nonprofit internet service provider, expanding access) C2","Working Groups":"","BDAC":""},{"Name":"Rosa Mendoza Davila","Position":"Executive Director, HTTP","Organization":"Hispanic Technology and Telecommunications Partnership's (HTTP)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Ronald Blackburn, Chairman, Board of Directors, HTTP","Category":"Advocacy (membership organization - members are nonprofit organizations that support advancement of hispanic people) C1","Working Groups":"WG1","BDAC":""},{"Name":"Tayler Mayer","Position":"Director, Public Relations","Organization":"TDI","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Claude Stout, Exec. Dir, TDI","Category":"Advocacy (nonprofit, advocates for access for deaf and hard of hearing individuals, expanding access) C1","Working Groups":"","BDAC":""},{"Name":"Todd O'Boyle","Position":"Deputy Director","Organization":"Next Century Cities","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (nonprofit - provides broadband, seeks collaboration) C2","Working Groups":"","BDAC":""},{"Name":"Tom Ferree","Position":"CEO","Organization":"Connected Nation","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Gov. Branstad (IA)","Nominated By":"Lindsay Conrad, Dir. Public Policy, Connected Nation","Category":"Advocacy (nonprofit - leading technology organization, facilitiates public/private partnerships to expand broadband, expanding access) C2","Working Groups":"","BDAC":""},{"Name":"Kyle Burgess","Position":"Executive Director","Organization":"Consumer's Research","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Advocacy (nonprofit - educational organization, mission to inform/promote consumers) C1","Working Groups":"","BDAC":""},{"Name":"Alison Greenwald Neplokh","Position":"Vice President of Spectrum Policy, Legal and Regulatory Affairs Department","Organization":"National Association of Broadcasters","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Gordon H. Smith, President & CEO, NAB","Category":"Association (nonprofit - reps broadcasters) D1*","Working Groups":"","BDAC":""},{"Name":"Benjamin Little","Position":"Board of Directors","Organization":"National Association of Tower Erectors","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Senate Commerce Committee, Majority Staff","Nominated By":"Todd Schlekeway, Executive director, NATE","Category":"Trade association (reps safety standards, education) (1) D1","Working Groups":"","BDAC":""},{"Name":"Bill Esbeck","Position":"Executive Director of the Wisconsin State Telecommunications Association (WSTA)","Organization":"Wisconsin State Telecommunications Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Sens. Baldwin and Johnson (WI)","Nominated By":"Bill Eckles, WSTA President","Category":"Association (telecommunications) D1*","Working Groups":"WG2","BDAC":""},{"Name":"Brent J. Christensen","Position":"President/CEO","Organization":"Minnesota Telecom Alliance","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Lewis (MN)","Nominated By":"Self-nominated","Category":"Association (nonprofit corporation – reps tellcommunications companies) (1) (2) D1*","Working Groups":"","BDAC":""},{"Name":"Brett Kilbourne","Position":"VP, Policy and General Counsel","Organization":"Utilities Telecom Council","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Association (nonprofit – reps tellecommunications companies) (1) D1*","Working Groups":"","BDAC":""},{"Name":"Brian S. Grossman** where we started delineating trade associations from \"advcacy\"","Position":"Attorney","Organization":"New England Wireless Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Tara Rand, President, New England Wireless Association (NEWA)","Category":"Trade association (nonprofit - reps wireless industry) D1*","Working Groups":"","BDAC":""},{"Name":"Carri Bennet","Position":"Managing Principal, Bennet & Bennet PLLC; General Counsel, RWA","Organization":"Rural Wireless Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Brian Woody, President, RWA","Category":"Trade association (nonprofit - reps rural wireless carriers) D1*","Working Groups":"","BDAC":""},{"Name":"Christine O'Connor","Position":"Executive Director","Organization":"Alaska Telephone Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Ed Cushing, President, Board of Alaska Telephone Association","Category":"Association (supports member companies in deploying broadband) D1*","Working Groups":"WG1","BDAC":""},{"Name":"Christopher B. Fisher","Position":"Attorney, Partner; President","Organization":"New York State Wireless Association; Cuddy & Feeder; (respectively)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Association (advocates for wireless industry in New York State) D1*","Working Groups":"","BDAC":""},{"Name":"David B. Dorwart","Position":"Chairman","Organization":"National Lifeline Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Trade association (nonprofit - \"focused on the Lifeline segment of telecommunications\") D1","Working Groups":"","BDAC":""},{"Name":"David Zelenok","Position":"Member","Organization":"American Public Works Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Ronald Calkins, APWA President","Category":"Association (nonprofit - reps for professionals in public works) D4","Working Groups":"","BDAC":""},{"Name":"Debbie Goldman","Position":"Policy Director, Telecommunications","Organization":"Communications Workers of America","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Christopher M. Shelton, President, Communications Workers of America","Category":"Membership organization, represents 700,000 workers in private and public sector employment) D4","Working Groups":"WG3","BDAC":""},{"Name":"Debra Berlyn","Position":"Member, Board of Directors","Organization":"National Consumers League","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Sally Greenberg, Executive Director, National Consumers League","Category":"Association (nonprofit, membership organization, reps consumers) D4","Working Groups":"WG3","BDAC":""},{"Name":"Edward Purcell","Position":"Attorney, Difrancesco, Bateman, Kunzman, Davis, Lehrer and Flaum PC","Organization":"New Jersey State League of Municipalities","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Michael F. Cerra, Assistant Executive Director & Director, Government Affairs, New Jersey League of Municipalities","Category":"Association (nonprofit - organization of NJ municipalities, provides legal assitance and inquiry service, policy development, etc.) D1","Working Groups":"","BDAC":""},{"Name":"Genevieve (Genny) Morelli","Position":"President","Organization":"The Voice of Mid-Size Communications Companies (ITTA)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Patrick Morse, Treasurer, ITTA","Category":"Association (reps communications industry) D1*","Working Groups":"WG3","BDAC":""},{"Name":"George H. Wyatt, Jr., P.E.","Position":"Member","Organization":"Association of Communication Engineers","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Tom R. Lewis, P.E., President, Association of Communication Engineers (ACE)","Category":"Association (nonprofit - organization of consulting engineering firms, provides professional development) D1","Working Groups":"WG1","BDAC":""},{"Name":"Gregory A. Barnes","Position":"General Counsel","Organization":"Digital Media Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Association (trade-like? advcacy - reps digital media industry) D1","Working Groups":"","BDAC":""},{"Name":"Heather Burnett Gold","Position":"President/CEO","Organization":"Fiber to the Home Council Americas","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Trade association (\"all-fiber trade association\" - aims to propel fiber deployment forward) D1*","Working Groups":"WG4","BDAC":""},{"Name":"Jason Goldman","Position":"VP, External Affairs & Stakeholder Engagement","Organization":"ITS America","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"F","Nominated By":"Self-nominated","Category":"Association (reps intelligent transportation) D1","Working Groups":"","BDAC":""},{"Name":"Jean Bonander","Position":"Executive Director","Organization":"California Street Light Association (CALSLA)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"CALSLA Executive Committee","Category":"Association (concerned with CHEAPER STREET LIGHTS in California...what is wrong with people) D4","Working Groups":"","BDAC":""},{"Name":"Jeff Letourneau","Position":"Executive Director, Networkmaine","Organization":"State Educational Technology Directors Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Tracy Weeks, Exec. Dir., SETDA","Category":"Association (nonprofit - launched by state education agency leaders to rep. interests/need in use of technology in teaching) D1","Working Groups":"","BDAC":""},{"Name":"Jerrod Henschel","Position":"SR Group Vice President, Michels Corp.","Organization":"Power & Communication Contractors Assoc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Trade association (national trade association for companies constructing electric power facilities) D1*","Working Groups":"","BDAC":""},{"Name":"Joseph Van Eaton","Position":"Partner, Best Best & Krieger LLP","Organization":"Michigan Municipal League","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"John LaMacchia II, Asst. Dir. For State and Federal Affairs, MML","Category":"Association (reps municipal interests) D1","Working Groups":"","BDAC":""},{"Name":"Karen Reidy","Position":"Vice President, Regulatory Affairs","Organization":"INCOMPAS (internet and competitive networks association)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Chip Pickering, CEO, INCOMPAS","Category":"Trade association (advocates on behalf of internet, streaming, communications and technology companies for competition-friendly policy) D1*","Working Groups":"","BDAC":""},{"Name":"Kristopher E. Twomey","Position":"Board of Directors","Organization":"Federation of Internet Solutions Providers Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jim Hollis, Executive Director, FISPA","Category":"Trade association (reps small, competitive carriers; Twomey himself works at a law firm) D1*","Working Groups":"","BDAC":""},{"Name":"Mark Johnson","Position":"Chief Technology Strategist, MCNC","Organization":"The Quilt","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Cort Buffington, KanREN; Timothy Lance, NYSERNet; John Gilespie, MORENet; Joe Sawasky, Merit Network; Lori Sorenson, Illinois DoIT; Cas D'Angelo, Southern Light Rail; Pankaj Shah, Lonestar ERN; Janet Cummings, EDUCAUSE; Anthony Copeland, NC Dep't of Commerce; Larry Steffann, Wireless Research Center of NC; Matt Hall, Internet2; Joanne Hovis, CTC","Nominated By":"Jen Leasure, President, The Quilt","Category":"Membership organization (\"national coalition,\" reps 36 networks across the country; facilitates nonprofit regional research and education networks to deploy cyberinfrastructure) D4*","Working Groups":"WG2","BDAC":""},{"Name":"Mark Radabaugh","Position":"Member, Board of Directors","Organization":"Wireless Internet Service Providers Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Alex Phillips, Board of Directors, WISPA","Category":"Association (nonprofit, reps ISPs) D1*","Working Groups":"WG2","BDAC":""},{"Name":"Mike Smith","Position":"Smith Communications","Organization":"Arkansas Oklahoma Wireless Assoc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Todd Williams, President/COO, CMS Wireless, and Vice President, Arkansas Oklahoma Wireless Association","Category":"Association (business association, members of the wireless industry) D1*","Working Groups":"","BDAC":""},{"Name":"Philip C. Merrill","Position":"President","Organization":"Wireless Communications Association (WCA)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Roxanne White, Vice President of WCA","Category":"Association (nonprofit business league - provides education to wireless industry** this guy is not the President or listed on the leadershp page of the website) D1*","Working Groups":"","BDAC":""},{"Name":"Rebecca Murphy Thompson","Position":"EVP & General Counsel","Organization":"Competitive Carriers Association (CCA)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Steven K. Berry, President & CEO, CCA","Category":"Association (reps competitive wireless carriers and stakeholders) D1*","Working Groups":"WG2","BDAC":""},{"Name":"Regina Hopper","Position":"President & Chief Executive Officer","Organization":"Intelligent Transportation Society of America","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Jason Goldman, VP, ITS America","Category":"Association (Intelligent Transportation Society of America - facilitates private/public partnerships and collaboration for more intelligent transportation systems) D1","Working Groups":"","BDAC":""},{"Name":"Reza Jafari","Position":"Senior Executive Advisor to the Board of Directors","Organization":"Wireless Broadband Alliance (WAB)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"JR Wilson, Chairman of the Board of Directors, WAB; Shrikant Shenwai, CEO WAB","Category":"Association (advocates for adoption of wireless broadband/broadband development - board members include AT&T and Boingo) D1*","Working Groups":"","BDAC":""},{"Name":"Rick Cimerman","Position":"Vice President, External and State Affairs","Organization":"NCTA - The Internet & Television Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Rick Chessen, Senior Vice President, Law and Public Policy, NCTA","Category":"Trade association (reps ISPs, anti-net neutrality) D1*","Working Groups":"WG2","BDAC":""},{"Name":"Ross Lieberman","Position":"Sr. Vice President, Government Affairs","Organization":"American Cable Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Matthew Polka, President and CEO, ACA","Category":"Association (reps ISPs and independent operators) D1*","Working Groups":"WG1","BDAC":""},{"Name":"Scott Bergmann","Position":"Vice President, Regulatory Affairs","Organization":"CTIA","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Brian Josef, Asst. VP, CTIA","Category":"Association (reps wireless communication industry) D1*","Working Groups":"WG4","BDAC":""},{"Name":"Sean Taketa McLaughlin","Position":"Executive Director, Access Humboldt","Organization":"Alliance for Community Media","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Mark Wassenaar, President and CEO, ACM","Category":"Membership organization (national membership organization - advocates for right to media training, distribution for diverse community voices) D4","Working Groups":"","BDAC":""},{"Name":"Shirley Bloomfield","Position":"Chief Executive Officer","Organization":"NTCA-The Rural Broadband Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Association (reps community-based telecommunications companies) D1*","Working Groups":"","BDAC":""},{"Name":"Snapper Carr","Position":"General Counsel, Focused Advcacy","Organization":"Texas Municipal League","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Scott Houston, TML","Category":"Association (\"league\" - membership of municipal leaders, mayors, city managers, etc.) D1","Working Groups":"","BDAC":""},{"Name":"Stacy S. Hannah","Position":"President & CEO","Organization":"Multi-Media Streaming Internet Association","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Self-nominated","Category":"Trade association (reps video streaming industry) D1","Working Groups":"","BDAC":""},{"Name":"Timothy Schneider","Position":"Public Counsel, Maine Office of Public Counsel","Organization":"NASUCA","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"David Springe, Exec. Dir., NASUCA","Category":"Association (reps interests of utility consumers) D4","Working Groups":"","BDAC":""},{"Name":"Tom Bliss","Position":"Member","Organization":"Northwest Rountable, Inc.","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"Rep. Graves (MO)","Nominated By":"Kathy Morgan, President, NWRI","Category":"Association (members include \"cities, counties and organizations\" - focus on economic development, total BS) D1","Working Groups":"","BDAC":""},{"Name":"Tom Stroup","Position":"President","Organization":"Satellite Industry Association, Inc. (SIA)","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Charity Weeden, Senior Director of Policy, SIA","Category":"Trade association (reps satellite companies) D1","Working Groups":"WG4","BDAC":""},{"Name":"Toniann Richard","Position":"CEO","Organization":"Health Care Collaborative of Rural Missouri","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Donna J. Brown, HCC Board of Directors","Category":"Association (healthcare) D1","Working Groups":"","BDAC":""},{"Name":"William Dutton","Position":"Director, Quello Center, Michigan State Univ.","Organization":"Michigan Assoc. for Computer Users in Learning","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Mark Smith, Exec. Dir., MACUL","Category":"Association (nonprofit - reps education community in use of educational technology) D1","Working Groups":"","BDAC":""},{"Name":"Jonathan Schwantes","Position":"Senior Policy Counsel, Telecommunications and Technology issues","Organization":"Consumers Union","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"","Nominated By":"Laura MacCleery, Vice President of Consumer Policy and Mobilization, Consumers Union","Category":"Membership organization (nonprofit, consumers union - passes consumer protection legislation) D4","Working Groups":"","BDAC":""},{"Name":"John Windhausen","Position":"Executive Director","Organization":"Schools, Health & Libraries Broadband (SHLB) Coalition","Alternate name":"","Alternate position":"","Photo":"","Description":"","Recommendations":"John Harrijngton, Funds for Learning","Nominated By":"Board of Directors, SHLB","Category":"Membership organization (concerned with open broadband connections, expanding access) D4","Working Groups":"","BDAC":""}]}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3);
module.exports = __webpack_require__(2);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// 0.2.9/script.js